<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.design form") }}</h2>
    </div>
   <div
  class="col-lg-2 align-self-center"
  v-if="DesignFormPrvRoute == 'studyProfile' || DesignFormPrvRoute == 'formTemplates'"
>
  <span class="tooltip-wrapper pointer" style="float:right">
    <i class="fa fa-times close" @click="onclosed()"></i>
    <span class="custom-tooltip closetooltipposition">Close</span>
  </span>
</div>

  </div>
  <div class="wrapper wrapper-content">
    <div class="row">
      <div class="col-md-3">
        <div class="ibox">
          <div class="ibox-title style_2 d-flex justify-content-between align-self-center">
            <h5 class="my-0 ">{{ $t("navigations.forms") }}</h5>
            <div
              v-if="rollsprivilages.includes('Designer Tool Create Form')"
              class="position-relative align-self-center"
              aria-label="Create form"
              tabindex="0"
            >
              <img
                class="cursor-pointer"
                src="../../assets/img/create.png"
                alt="Create form"
                width="20"
                @click="createForm()"
              />
              <div class="tool-tip">{{ $t("navigations.create form") }}</div>
            </div>
          </div>
          <div class="ibox-content scroll_horizontal p-2">
            <div class="template-body">
              <div class="panel-group" id="accordion">
                <div
                  class="panel panel-default"
                  v-for="form in listforms"
                  :key="form.id"
                >
                  <div
                    class="panel-heading d-flex justify-content-between py-1"
                  >
                    <h5
                      class="panel-title cursor-pointer"
                      tabindex="0"
                      :aria-collapsed="collapseDiv[form.templateId]"
                      :aria-label="form.templateName"
                      :id="form.id"
                      @click.prevent="
                        (collapseDiv[form.templateId] = !collapseDiv[
                          form.templateId
                        ]),
                          getPages(
                            form.templateFormId,
                            form.sourceTemplateId,
                            form.version,
                            form.templateName
                          )
                      "
                    >
                      {{ form.templateName }}
                    </h5>
                    <div
                      class="expand-delete-block cursor-pointer align-self-center position-relative px-2"
                      tabindex="0"
                      aria-label="Expand options"
                      @click.prevent="
                        getPages(
                          form.templateFormId,
                          form.sourceTemplateId,
                          form.version,
                          form.templateName
                        ),
                          (showSideModal[form.templateId] = !showSideModal[
                            form.templateId
                          ])
                      "
                      v-on:clickout="showSideModal[form.templateId] = false"
                    >
                      <i class="fa fa-ellipsis-v"></i>
                      <div
                        class="side-popup position-absolute py-2"
                        v-if="
                          showSideModal[form.templateId] &&
                            this.rollsprivilages.includes(
                              'Designer Tool Create Form'
                            )
                        "
                      >
                        <div
                          class="d-flex px-3"
                          @click.prevent="
                            createVersionClicked(
                              form.templateFormId,
                              form.version,
                              form.sourceTemplateId,
                              form.therapeuticArea,
                              form.therapeuticAreaId,
                              form.categoryId,
                              form.category,
                            )
                          "
                        >
                          <i
                            class="fa fa-code-fork icon-color align-self-center pr-2"
                          ></i>
                          <span>{{ $t("navigations.create new version") }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel-collapse">
                    <div class="template-body">
                      <ul class="template-list px-0 mb-0">
                        <!-- {{ pages }} -->
                        <!-- <li v-for="page in pages[form.id]" :key="page.pageNo" class="px-3 cursor-pointer" :id="page.pageName" @click="changepage(form.id,page.pageNo,page.pageName)" -->
                        <li
                          v-for="page in pages[form.sourceTemplateId]"
                          :key="page.pageNo"
                          class="px-3 cursor-pointer"
                          :id="page.pageName + form.sourceTemplateId"
                          @click="
                            changepage(
                              form.templateId,
                              pages[form.sourceTemplateId],
                              page,
                              form.sourceTemplateId,
                              form.version,
                              form.templateName
                            )
                          "
                          :class="{
                            'py-2': collapseDiv[form.templateId],
                            'max-height-30': collapseDiv[form.templateId],
                            'max-height-0': !collapseDiv[form.templateId],
                          }"
                        >
                          {{ page.pageName }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="row">
          <div class="col-md-10 maincontents py-3" v-if="showForm == true">
            <div
              class="ibox-content-edit-toolbar d-flex justify-content-between align-items-center"
              @click.prevent="columnselected = false"
            >
              <h4 class="my-0">{{ formname }}</h4>
              <div
                class="text-right d-flex"
                v-if="rollsprivilages.includes('Designer Tool Create Form')"
              >
                <div class="d-flex">
                  <span class="mr-2">{{ $t("navigations.version") }}</span>
                  <select
                    v-model="version"
                    class="form-control mr-2 version"
                    @change="handleDropdownChange()"
                  >
                    <option
                      v-for="versions in versionhistoryarray"
                      :key="versions.version"
                      :value="versions.version"
                    >
                      {{ versions.version }}
                    </option>
                  </select>
                  <span id="validationtooltip" class="pointer">
                    Maximum character limit has been reached
                  </span>
                </div>
                <div
                  v-if="temparray.length != 0 && !isformlocked"
                  class="position-relative"
                >
                  <img
                    class="cursor-pointer me-3"
                    src="../../assets/save_fd.svg"
                    alt="Save template"
                    @click.prevent="savetestfun(`showalert`)"
                  />
                  <div class="tool-tip">{{ $t("navigations.save form") }}</div>
                </div>
                <div
                  v-if="temparray.length != 0 && !isformlocked"
                  class="position-relative"
                >
                  <img
                    class="cursor-pointer me-3"
                    src="../../assets/delete_fd.svg"
                    alt="Delete Page"
                    @click.prevent="deletepagefun()"
                  />
                  <div class="tool-tip">{{ $t("navigations.delete page") }}</div>
                </div>
                <div
                  v-if="temparray.length != 0 && !isformlocked"
                  class="position-relative"
                >
                  <img
                    class="cursor-pointer me-3"
                    src="../../assets/delete_col_fd.svg"
                    alt="Delete Column"
                    @click.prevent="deletegroupfun()"
                  />
                  <div class="tool-tip">{{ $t("navigations.delete column") }}</div>
                </div>
                <!-- view template -->
                <div
                  class="position-relative"
                >
                  <img
                    class="cursor-pointer me-3"
                    src="../../assets/view_temp_fd.svg"
                    alt="View Template"
                    @click.prevent="viewtemplatefun()"
                  />
                  <div class="tool-tip">{{ $t("navigations.view form") }}</div>
                </div>
                <div
                  class="position-relative"
                  v-if="status == `New` || !isformlocked"
                >
                  <img
                    class="cursor-pointer"
                    src="../../assets/design_complete_fd.svg"
                    alt="Design Complete"
                    @click.prevent="designcompletepopupfun()"
                  />
                  <div class="tool-tip">{{ $t("navigations.design complete") }}</div>
                </div>

                <!-- <a class="me-2 savebutton" href="#" @click.prevent="updatefun('update')"
                data-toggle="tooltip" data-placement="top" title="Update Template"><img src="../../assets/update.png" alt="" /></a> -->
              </div>
            </div>
            <div
              class="maincontainer"
              @drop="drop($event, elementUsed)"
              @dragenter.prevent
              @dragover.prevent
            >
              <div v-for="input in temparray" :key="input">
                <div
                  class="mainbgchange getcontents"
                  v-for="(item, key) in input.pages"
                  :key="key"
                >
                  <form>
                    <div class="form-group">
                      <div>
                        <div
                          v-if="item.pageNo == pageno"
                          class="pageContainer mt-0"
                        >
                        <div class="d-flex justify-content-between p-3">
                          <div class="form-logos">
                              <img class="float-left" src="../../assets/img/IDSLogo.png" alt="" />
                          </div>
                          
                          <div class="form-logos">
                              <img class="float-right" src="../../assets/img/client_Logo.png" alt="" />
                          </div>
                      </div>
                          <div :class="{elements_container: item.Group.length > 2,}" class="pt-3">
                            <div
                              class="groupsdiv mainbgchange showbtms"
                              v-for="(groupno, key) in item.Group"
                              :key="key"
                             >
                             <span v-if="showForm === true && !isformlocked" class="delete-icon margintop">
                             <div class="position-relative" @click="deleteGroup(key)">
                              <img src="../../assets/add_row_btn.png" alt="Add Group" class="add-icon" @click.prevent="createnewgroup(groupno)">
                              <div class="tool-tip">Add Row</div>
                             </div>
                            </span>
                              <div class="flexContainer mainbgchange">
                                <template
                                  v-for="(newfield, key) in groupno.field"
                                  :key="key"
                                >
                                  <div
                                    v-if="newfield"
                                    class="flex-sub-container mainbgchange"
                                  >
                                    <!-- headder starts -->
                                    <div
                                      :class="
                                        highlitedcolumn == newfield.fieldName
                                          ? 'dummydata dummydataenter'
                                          : 'dummydata'
                                      "
                                      tabindex="0"
                                      v-if="newfield.type == 'blankdata'"
                                      :data-selected="columnselected"
                                      @dragenter="selectspot(newfield, groupno)"
                                      @click.prevent="
                                        selectspot(newfield, groupno)
                                      "
                                    ></div>
                                    <!-- headder ends -->
                                    <!-- headder starts -->
                                    <div
                                      v-if="newfield.type == 'header'"
                                      class="headerdiv"
                                      @click.prevent="
                                        inputfieldedit(newfield, groupno)
                                      "
                                    >
                                    
                                    <div class="text-center">
                                      <h4>{{ newfield.label }}</h4>
                                      </div>
                                    </div>
                                    <!-- headder ends -->
                                    <!-- input starts -->
                                    <div
                                      v-else-if="inputElements.includes(newfield.type)"
                                      class="flex-item bgblue"
                                    >
                                      <div class="labelclass">
                                        {{ newfield.label}}
                                        <sup
                                          v-if="
                                            newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required') || newfield.validation.includes('REQUIRED')"
                                          ><i class="fa fa-asterisk required"></i>
                                        </sup>
                                      </div>
                                      <input
                                        class="form-control"
                                        :label="newfield.label"
                                        type="text"
                                        @click.prevent="inputfieldedit(newfield, groupno)"
                                      />
                                    </div>
                                    <!-- input ends -->
                                    <!-- image starts -->
                                    <div
                                      v-else-if="newfield.type == 'image'"
                                      class="flex-item displayflex"
                                      @click.prevent="
                                        inputfieldedit(newfield, groupno)
                                      "
                                    >
                                      <div>
                                        <div
                                          class="labelclass marginauto"
                                        ></div>
                                      </div>
                                      <img
                                        class="templatepreview"
                                        :src="
                                          `${fileuploadurl}/file/${
                                            newfield.imagePath.split(',')[0]
                                          }?versionid=${
                                            newfield.imagePath.split(',')[1]
                                          }`
                                        "
                                      />
                                    </div>
                                    <!-- image ends -->
                                    <!-- scales starts -->
                                    <div
                                      v-else-if="newfield.type == 'scales'"
                                      class="flex-item"
                                    >
                                      <div>
                                        <div class="labelclass">
                                          {{ newfield.label}}
                                          <sup v-if="
                                              newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required')  ||
                                            newfield.validation.includes('REQUIRED')">
                                               <i class="fa fa-asterisk required"></i>
                                          </sup>
                                        </div>
                                        <input
                                          class="form-control scaleval"
                                          type="number"
                                          :min="parseInt(newfield.limit[0].min)"
                                          :max="parseInt(newfield.limit[0].max)"
                                          v-model="newfield.value"
                                          @click.prevent="
                                            inputfieldedit(newfield, groupno)
                                          "
                                        />
                                        <input
                                          type="range"
                                          class="rangeclass"
                                          :min="parseInt(newfield.limit[0].min)"
                                          :max="parseInt(newfield.limit[0].max)"
                                          step="1"
                                          v-model="newfield.value"
                                          @click.prevent="
                                            inputfieldedit(newfield, groupno)
                                          "
                                        />

                                        <span v-text="total"></span>
                                      </div>
                                    </div>
                                    <!-- scales ends -->
                                    <!-- time element starts -->
                                    <div
                                      v-else-if="newfield.type == 'time'"
                                      class="flex-item bgblue"
                                    >
                                      <div class="labelclass">{{ newfield.label}}
                                        <sup v-if="
                                            newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required') || newfield.validation.includes('REQUIRED')"
                                          ><i class="fa fa-asterisk required"></i>
                                        </sup>
                                      </div>
                                      <input
                                        class="form-control"
                                        classname="time"
                                        :label="newfield.label"
                                        type="time"
                                        @click.prevent="inputfieldedit(newfield, groupno)"
                                      />
                                    </div>
                                    <!-- time element ends -->
                                    <!-- date element starts -->
                                    <div
                                      v-else-if="newfield.type == 'date'"
                                      class="flex-item bgblue"
                                    >
                                      <div class="labelclass">
                                        {{ newfield.label
                                        }}<sup
                                          v-if="
                                            newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required') || 
                                            newfield.validation.includes('REQUIRED') 
                                          "
                                          ><i class="fa fa-asterisk required"></i
                                        ></sup>
                                      </div>
                                      <input
                                        class="form-control"
                                        classname="date"
                                        :label="newfield.label"
                                        type="date"
                                        @click.prevent="
                                          inputfieldedit(newfield, groupno)
                                        "
                                      />
                                    </div>
                                    <!-- date element ends -->
                                    <!-- dateandtime element starts -->
                                    <div
                                      v-else-if="newfield.type == 'dateandtime'"
                                      class="flex-item bgblue"
                                    >
                                      <div class="labelclass">
                                        {{ newfield.label
                                        }}<sup
                                          v-if="
                                            newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required') || 
                                            newfield.validation.includes('REQUIRED') 
                                          "
                                          ><i class="fa fa-asterisk required"></i
                                        ></sup>
                                      </div>
                                      <input
                                        class="form-control"
                                        classname="date"
                                        :label="newfield.label"
                                        type="datetime-local"
                                        @click.prevent="
                                          inputfieldedit(newfield, groupno)
                                        "
                                      />
                                    </div>
                                    <!-- date element ends -->
                                    <!-- text area starts -->
                                    <div
                                      class="elem"
                                      v-else-if="
                                        (newfield.type == 'description') |
                                          (newfield.type == 'textarea')
                                      "
                                    >
                                      <div class="txtarealabel">
                                        <label
                                          :for="newfield.fieldName"
                                          class="textsize mb-0"
                                          >{{ newfield.label
                                          }}<sup
                                            v-if="
                                              newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required') || 
                                            newfield.validation.includes('REQUIRED')
                                            "
                                            ><i
                                              class="fa fa-asterisk required"
                                            ></i></sup
                                        ></label>
                                      </div>
                                      <div class="txtar">
                                        <textarea
                                          :id="newfield.fieldName"
                                          :name="newfield.fieldName"
                                          class="textbox"
                                          @click.prevent="
                                            inputfieldedit(newfield, groupno)
                                          "
                                        />
                                      </div>
                                    </div>
                                    <!-- text area ends -->
                                    <!-- checkboxes starts -->
                                    <div
                                      v-else-if="newfield.type == 'checkbox'"
                                      class="form-group sticktobottom checkboxcontainer"
                                      @click.prevent="
                                        inputfieldedit(newfield, groupno)
                                      "
                                    >
                                      <div class="pb-2">
                                        <input
                                          type="checkbox"
                                          :id="newfield.fieldName"
                                          :name="newfield.fieldName"
                                        /><span class="labelclass ml-2">
                                          {{ newfield.label }}
                                          <sup
                                            v-if="
                                              newfield.validation.includes('required') ||
                                              newfield.validation.includes('Required') || 
                                              newfield.validation.includes('REQUIRED') 
                                            "
                                            ><i class="fa fa-asterisk required"></i></sup>
                                        </span>
                                      </div>
                                    </div>
                                    <!-- checkboxes ends -->
                                    <!-- radio button starts -->
                                    <div
                                      v-else-if="newfield.type == 'radio' && newfield.align =='vertical'"
                                      class="form-group labelclass sticktobottom"
                                      @click.prevent="
                                        inputfieldedit(newfield, groupno)
                                      "
                                    >
                                      <div class="radiogroupclass">
                                        {{ newfield.label
                                        }}<sup
                                          v-if="
                                            newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required') ||
                                            newfield.validation.includes('REQUIRED') 
                                          "
                                          ><i class="fa fa-asterisk required"></i
                                        ></sup>
                                        <div
                                          class="radiogroupclass"
                                          v-for="options in newfield.options"
                                          :key="options"
                                        >
                                          <input
                                            type="radio"
                                            class="mr-2"
                                            :name="newfield.fieldName"
                                            :id="newfield.fieldName"
                                          />{{ options.optionname }}
                                        </div>
                                      </div>
                                    </div>
                                    <!-- radio button ends -->
                                    <!-- radio button horizontal starts -->
                                    <div
                                      v-else-if="newfield.type == 'radio' && newfield.align !='vertical'"
                                      class="form-group labelclass sticktobottom"
                                      @click.prevent="
                                        inputfieldedit(newfield, groupno)
                                      "
                                    >
                                      <div class="radiohorizondalclass">
                                        <div class="radiolabelclass">
                                          {{ newfield.label }}
                                          <sup
                                          v-if="
                                            newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required') ||
                                            newfield.validation.includes('REQUIRED') "
                                          ><i class="fa fa-asterisk required"></i>
                                        </sup>
                                        </div>
                                        <div
                                          class="radiogroupclass"
                                          v-for="options in newfield.options"
                                          :key="options"
                                        >
                                          <input
                                            type="radio"
                                            class="mr-2 ml-2"
                                            :name="newfield.fieldName"
                                            :id="newfield.fieldName"
                                          />{{ options.optionname }}
                                        </div>
                                      </div>
                                    </div>
                                    <!-- radio button ends -->
                                    <!-- dropdown menu starts -->
                                    <div
                                      v-else-if="newfield.type == 'dropdown'"
                                      class="flex-item bgblue"
                                      @click.prevent="
                                        inputfieldedit(newfield, groupno)
                                      "
                                    >
                                      <div class="labelclass">
                                        {{ newfield.label
                                        }}<sup
                                          v-if="
                                            newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required') ||
                                            newfield.validation.includes('REQUIRED') 
                                          "
                                          ><i class="fa fa-asterisk required"></i
                                        ></sup>
                                      </div>
                                      <div
                                        @click.prevent="
                                          inputfieldedit(newfield, groupno)
                                        "
                                        class="baseselect mainbgchange selectzindex" 
                                      >
                                        <input
                                          class="form-control bg-light fill-form-select"
                                          :label="newfield.label"
                                          type="text"
                                          @click.prevent="inputfieldedit(newfield, groupno)"
                                        />
                                        <!-- <select
                                          class="form-control dropdownbackground"
                                          disabled="true;"
                                          
                                        >
                                          <option
                                            
                                          >
                                            {{ newfield.options[0] }}
                                          </option>
                                        </select> -->
                                      </div>
                                    </div>
                                    <!-- dropdown menu ends -->
                                    <!-- notes starts -->
                                    <div
                                      class="ml-2 pb-2"
                                      v-else-if="newfield.type == 'notes'"
                                      @click.prevent="
                                        inputfieldedit(newfield, groupno)
                                      "
                                    >
                                      <div class="font-15">
                                        <i>{{ newfield.label }}</i>
                                      </div>
                                    </div>
                                    <!-- notes ends -->
                                    <!-- file upload starts -->
                                    <div
                                      v-else-if="newfield.type == 'uploadfile'"
                                      class="flex-item"
                                    >
                                      <div class="labelclass">
                                        {{ newfield.label
                                        }}<sup
                                          v-if="
                                            newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required') ||
                                            newfield.validation.includes('REQUIRED') 
                                          "
                                          ><i class="fa fa-asterisk required"></i
                                        ></sup>
                                      </div>
                                      <div class="twoitemflex">
                                        <input
                                          class="form-control"
                                          :label="newfield.label"
                                          type="file"
                                          @click.prevent="
                                            inputfieldedit(newfield, groupno)
                                          "
                                        />
                                      </div>
                                    </div>
                                    <!-- file upload ends -->
                                    <!-- year starts -->
                                    <div
                                      v-else-if="newfield.type == 'year'"
                                      class="flex-item"
                                    >
                                      <div class="labelclass">
                                        {{ newfield.label
                                        }}<sup
                                          v-if="
                                            newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required') ||
                                            newfield.validation.includes('REQUIRED') 
                                          "
                                          ><i class="fa fa-asterisk required"></i
                                        ></sup>
                                      </div>
                                      <input
                                        class="form-control"
                                        :label="newfield.label"
                                        type="number"
                                        min="1900"
                                        max="2099"
                                        step="1"
                                        @click.prevent="
                                          inputfieldedit(newfield, groupno)
                                        "
                                      />
                                    </div>
                                    <!-- year ends -->
                                    <!-- calculation starts -->
                                    <div
                                      v-else-if="newfield.type == 'calculation'"
                                      class="flex-item"
                                      @click.prevent="
                                        inputfieldedit(newfield, groupno)
                                      "
                                    >
                                      <div class="labelclass">{{ newfield.label }} </div>
                                    </div>
                                    <!-- calculation ends -->
                                    <!-- summery starts -->
                                    <div
                                      class="ml-2 pb-2 font-15"
                                      v-else-if="newfield.type == 'summary'"
                                      @click.prevent="inputfieldedit(newfield, groupno)"
                                    >
                                      <i>
                                        {{ newfield.label }}   
                                      </i>
                                    </div>
                                    <!-- summery ends -->
                                    <!-- qr code starts -->
                                    <div
                                            class="elem"
                                            v-else-if="
                                              newfield.type == 'qrcode'
                                            "
                                            @click.prevent="
                                              inputfieldedit(newfield, groupno)
                                            "
                                          >
                                            <div hidden>
                                              {{
                                                qrcodefun(
                                                  newfield.fieldName,
                                                  newfield.qrData
                                                )
                                              }}
                                            </div>
                                            <div class="position-relative">
                                            <img
                                              class="qrcodeframe"
                                              @click.prevent="inputfieldedit(newfield, groupno)"
                                              :src="
                                                qrcodetxt[newfield.fieldName]
                                              "
                                              title="qr code"/>
                                            <div class="overlay" @click.prevent="inputfieldedit(newfield, groupno)"></div>
                                          </div>
                                    </div>
                                    <!-- qr code ends -->
                                    <!-- Grid starts -->
                                    <div
                                      class="elem"
                                      v-else-if="newfield.type == 'grid'"
                                      @click.prevent="
                                        inputfieldedit(newfield, groupno)
                                      "
                                    >
                                      <div
                                        v-if="
                                          gridoptarray[newfield.fieldName] ==
                                            undefined
                                        "
                                        hidden
                                      >
                                        {{
                                          gridoptfun(
                                            newfield.fieldName,
                                            newfield.options[0]
                                          )
                                        }}
                                      </div>
                                      <div
                                        class="notesstyle gridbackground gridelem"
                                      >
                                        <div
                                          class="ibox-content-edit flextable gridbackground"
                                        >
                                          <div class="addfieldtable">
                                            <div
                                              class="rowcolmn"
                                              v-for="(gridrow,
                                              index) in gridoptarray[
                                                newfield.fieldName
                                              ][0].Rows"
                                              :key="gridrow"
                                            >
                                              <div class="rowlabelgrid">
                                                {{ gridrow }}
                                              </div>
                                              <div
                                                class="rowcolmnc"
                                                v-for="gridcolumn in gridoptarray[
                                                  newfield.fieldName
                                                ][0].Columns"
                                                :key="gridcolumn"
                                              >
                                                <div v-if="index == 0">
                                                  {{ gridcolumn }}
                                                </div>
                                                <input
                                                  class="form-control"
                                                  v-model="
                                                    griddata[0].Columns[
                                                      gridcolumn - 1
                                                    ]
                                                  "
                                                  type="text"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- Grid ends -->
                                    <!-- add survey starts -->
                                    <div
                                      class="elem"
                                      v-else-if="newfield.type == 'addsurvey'"
                                    >
                                      <div class="survey">
                                        <button
                                          type="button"
                                          class="btn btn-outline-primary"
                                          @click.prevent="addsurvey()"
                                        >
                                          {{ newfield.label }}
                                        </button>
                                      </div>
                                    </div>
                                    <!-- add survey ends -->
                                    <!-- numberanddate starts -->
                                    <div
                                      v-else-if="
                                        newfield.type == 'numberanddate'
                                      "
                                      class="flex-item"
                                    >
                                      <div class="labelclass">
                                        {{ newfield.label}}<sup
                                          v-if="
                                            newfield.validation.includes('required') ||
                                            newfield.validation.includes('Required') ||
                                            newfield.validation.includes('REQUIRED') 
                                          "
                                          ><i class="fa fa-asterisk required"></i
                                        ></sup>
                                      </div>
                                      <div class="d-flex">
                                        <input
                                          class="form-control"
                                          :label="newfield.label"
                                          type="number"
                                          @click.prevent="
                                            inputfieldedit(newfield, groupno)
                                          "
                                        />
                                        <input
                                          class="form-control"
                                          :label="newfield.label"
                                          type="date"
                                          @click.prevent="
                                            inputfieldedit(newfield, groupno)
                                          "
                                        />
                                      </div>
                                    </div>
                                    <!-- numberanddate ends -->
                                    <!-- subHeader starts -->
                                    <div
                                      v-else-if="newfield.type == 'subHeader'"
                                      class="subheadder"
                                      @click.prevent="
                                        inputfieldedit(newfield, groupno)
                                      "
                                    >
                                      <h4>{{ newfield.label }}</h4>
                                    </div>
                                    <!-- repeatedmeasure starts -->
                                    <div v-else-if="newfield.type == 'repeatingfield'" :key="newfield">
                                      <h6 class="headerdiv"> {{newfield.label}} </h6>
                                      <div>
                                        <div
                                          class="mainbgchange getcontents"
                                          @click.prevent="editrepeatedmeasure(newfield, groupno)"
                                        >
                                          <form>
                                            <div class="form-group repeatContainer">
                                              <div>
                                                <div class="pageContainer mt-2">
                                                  <div>
                                                    <div>
                                                      <div>
                                                        <div class="flexContainer mainbgchange"
                                                              v-for="(repgroupno, key) in repeatedgroupgroupnos[newfield.fieldName]"
                                                                    :key="key">
                                                        <template
                                                          v-for="(newrepeatingFields, newrepkey) in newfield.repeatingFields"
                                                                :key="newrepkey"
                                                        >
                                                        <div
                                                            v-if="newrepeatingFields.groupOrderNo == repgroupno"
                                                            class="flex-sub-container mainbgchange"
                                                          >
                                                            <!-- headder starts -->
                                                            <div
                                                              v-if="newrepeatingFields.type == 'header'"
                                                              class="headerdiv"
                                                            >
                                                            <div class="text-center">
                                                              <h4>{{ newrepeatingFields.label }}</h4>
                                                              </div>
                                                            </div>
                                                            <!-- headder ends -->
                                                            <!-- input starts -->
                                                            <div
                                                              v-else-if="
                                                                inputElements.includes(newrepeatingFields.type)
                                                              "
                                                              class="flex-item bgblue"
                                                            >
                                                              <div class="labelclass">
                                                                {{ newrepeatingFields.label
                                                                }}<sup
                                                                  v-if="
                                                                    newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required') ||
                                                                      newrepeatingFields.validation.includes('REQUIRED') 
                                                                  "
                                                                  ><i class="fa fa-asterisk required"></i
                                                                ></sup>
                                                              </div>
                                                              <input
                                                                class="form-control"
                                                                :label="newrepeatingFields.label"
                                                                type="text"
                                                              />
                                                            </div>
                                                            <!-- input ends -->
                                                            <!-- image starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'image'"
                                                              class="flex-item displayflex"
                                                            >
                                                              <div>
                                                                <div
                                                                  class="labelclass marginauto"
                                                                ></div>
                                                              </div>
                                                              <img
                                                                class="templatepreview"
                                                                :src="
                                                                  `${fileuploadurl}/file/${
                                                                    newrepeatingFields.imagePath.split(',')[0]
                                                                  }?versionid=${
                                                                    newrepeatingFields.imagePath.split(',')[1]
                                                                  }`
                                                                "
                                                              />
                                                            </div>
                                                            <!-- image ends -->
                                                            <!-- scales starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'scales'"
                                                              class="flex-item"
                                                            >
                                                            
                                                            <div class="labelclass">
                                                                  {{ newrepeatingFields.label}}
                                                                  <sup v-if="
                                                                       newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required')  ||
                                                                       newrepeatingFields.validation.includes('REQUIRED')"
                                                                    > <i class="fa fa-asterisk required"></i>
                                                                  </sup>
                                                                </div>
                                                                <div class="d-flex">
                                                                  <h6>{{ newrepeatingFields.limit[0].min }}</h6>
                                                                <input
                                                                  type="range"
                                                                  class="rangeclass"
                                                                  :min="parseInt(newrepeatingFields.limit[0].min)"
                                                                  :max="parseInt(newrepeatingFields.limit[0].max)"
                                                                  step="1"
                                                                  v-model="newrepeatingFields.value"
                                                                />
                                                                <h6>{{ newrepeatingFields.limit[0].max }}</h6>
                                                                
                                                              <div>
                                                                
                                                                <input
                                                                  class="form-control scaleval"
                                                                  type="number"
                                                                  :min="parseInt(newrepeatingFields.limit[0].min)"
                                                                  :max="parseInt(newrepeatingFields.limit[0].max)"
                                                                  v-model="newrepeatingFields.value"
                                                                />
                                                               
                                                                <span v-text="total"></span>
                                                              </div>
                                                            </div>
                                                            </div>
                                                            <!-- scales ends -->
                                                            <!-- time element starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'time'"
                                                              class="flex-item bgblue"
                                                            >
                                                              <div class="labelclass">
                                                                {{ newrepeatingFields.label
                                                                }}<sup
                                                                  v-if="
                                                                     newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required') ||
                                                                      newrepeatingFields.validation.includes('REQUIRED')
                                                                  "
                                                                  ><i class="fa fa-asterisk required"></i
                                                                ></sup>
                                                              </div>
                                                              <input
                                                                class="form-control"
                                                                classname="time"
                                                                :label="newrepeatingFields.label"
                                                                type="time"
                                                              />
                                                            </div>
                                                            <!-- time element ends -->
                                                            <!-- date element starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'date'"
                                                              class="flex-item bgblue"
                                                            >
                                                              <div class="labelclass">
                                                                {{ newrepeatingFields.label
                                                                }}<sup
                                                                  v-if="
                                                                     newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required') ||
                                                                      newrepeatingFields.validation.includes('REQUIRED')
                                                                  "
                                                                  ><i class="fa fa-asterisk required"></i
                                                                ></sup>
                                                              </div>
                                                              <input
                                                                class="form-control"
                                                                classname="date"
                                                                :label="newrepeatingFields.label"
                                                                type="date"
                                                              />
                                                            </div>
                                                            <!-- date element ends -->
                                                            <!-- dateandtime element starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'dateandtime'"
                                                              class="flex-item bgblue"
                                                            >
                                                              <div class="labelclass">
                                                                {{ newrepeatingFields.label
                                                                }}<sup
                                                                  v-if="
                                                                     newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required') ||
                                                                      newrepeatingFields.validation.includes('REQUIRED')
                                                                  "
                                                                  ><i class="fa fa-asterisk required"></i
                                                                ></sup>
                                                              </div>
                                                              <input
                                                                class="form-control"
                                                                classname="date"
                                                                :label="newrepeatingFields.label"
                                                                type="datetime-local"
                                                              />
                                                            </div>
                                                            <!-- date element ends -->
                                                            <!-- text area starts -->
                                                            <div
                                                              class="elem"
                                                              v-else-if="
                                                                (newrepeatingFields.type == 'description') |
                                                                  (newrepeatingFields.type == 'textarea')
                                                              "
                                                            >
                                                              <div class="txtarealabel">
                                                                <label
                                                                  :for="newrepeatingFields.fieldName"
                                                                  class="textsize mb-0"
                                                                  >{{ newrepeatingFields.label
                                                                  }}<sup
                                                                    v-if="
                                                                       newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required') ||
                                                                      newrepeatingFields.validation.includes('REQUIRED')
                                                                    "
                                                                    ><i
                                                                      class="fa fa-asterisk required"
                                                                    ></i></sup
                                                                ></label>
                                                              </div>
                                                              <div class="txtar">
                                                                <textarea
                                                                  :id="newrepeatingFields.fieldName"
                                                                  :name="newrepeatingFields.fieldName"
                                                                  class="textbox"
                                                                />
                                                              </div>
                                                            </div>
                                                            <!-- text area ends -->
                                                            <!-- checkboxes starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'checkbox'"
                                                              class="form-group sticktobottom checkboxcontainer"
                                                            >
                                                              <div class="pb-2">
                                                                <input
                                                                  type="checkbox"
                                                                  :id="newrepeatingFields.fieldName"
                                                                  :name="newrepeatingFields.fieldName"
                                                                /><span class="labelclass ml-2">
                                                                  {{ newrepeatingFields.label }}
                                                                    <sup
                                                                    v-if="
                                                                       newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required') ||
                                                                      newrepeatingFields.validation.includes('REQUIRED')"
                                                                    ><i class="fa fa-asterisk required"></i
                                                                  ></sup>
                                                                </span>
                                                              </div>
                                                            </div>
                                                            <!-- checkboxes ends -->
                                                            <!-- radio button starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'radio' && newrepeatingFields.align =='vertical'"
                                                              class="form-group labelclass sticktobottom"
                                                            >
                                                              <div class="radiogroupclass">
                                                                {{ newrepeatingFields.label}}
                                                                <sup
                                                                  v-if="
                                                                     newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required') ||
                                                                      newrepeatingFields.validation.includes('REQUIRED')"
                                                                  ><i class="fa fa-asterisk required"></i
                                                                ></sup>
                                                                <div
                                                                  class="radiogroupclass"
                                                                  v-for="options in newrepeatingFields.options"
                                                                  :key="options"
                                                                >
                                                                  <input
                                                                    type="radio"
                                                                    class="mr-2"
                                                                    :name="newrepeatingFields.fieldName"
                                                                    :id="newrepeatingFields.fieldName"
                                                                  />{{ options.optionname }}
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- radio button ends -->
                                                            <!-- radio button horizontal starts -->
                                                            <div
                                                              v-else-if="
                                                                newrepeatingFields.type == 'radio' && newrepeatingFields.align !='vertical'
                                                              "
                                                              class="form-group labelclass sticktobottom"
                                                            >
                                                              <div class="radiohorizondalclass">
                                                                <div class="radiolabelclass">
                                                                  {{ newrepeatingFields.label }}
                                                                  <sup
                                        v-if="
                                        newrepeatingFields.validation[0] ==
                                              'required' ||
                                              newrepeatingFields.validation[0] ==
                                                'Required'
                                          || newrepeatingFields.validation[0]=='REQUIRED' "><i
                                                  class="fa fa-asterisk required"
                                                ></i
                                              ></sup>
                                                                </div>
                                                                <div
                                                                  class="radiogroupclass"
                                                                  v-for="options in newrepeatingFields.options"
                                                                  :key="options"
                                                                >
                                                                  <input
                                                                    type="radio"
                                                                    class="mr-2 ml-2"
                                                                    :name="newrepeatingFields.fieldName"
                                                                    :id="newrepeatingFields.fieldName"
                                                                  />{{ options.optionname }}
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- radio button ends -->
                                                            <!-- dropdown menu starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'dropdown'"
                                                              class="flex-item bgblue"
                                                            >
                                                              <div class="labelclass">
                                                                {{ newrepeatingFields.label
                                                                }}<sup
                                                                  v-if="
                                                                     newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required') ||
                                                                      newrepeatingFields.validation.includes('REQUIRED')
                                                                  "
                                                                  ><i class="fa fa-asterisk required"></i
                                                                ></sup>
                                                              </div>
                                                              <div
                                                                class="baseselect mainbgchange selectzindex"
                                                              >
                                                                <input
                                                                  class="form-control bg-light fill-form-select"
                                                                  :label="newrepeatingFields.label"
                                                                  type="text"
                                                                />
                                                              </div>
                                                            </div>
                                                            <!-- dropdown menu ends -->
                                                            <!-- notes starts -->
                                                            <div
                                                              class="ml-2 pb-2"
                                                              v-else-if="newrepeatingFields.type == 'notes'"
                                                            >
                                                              <div class="notesstyle">
                                                                {{ newrepeatingFields.label }}
                                                              </div>
                                                            </div>
                                                            <!-- notes ends -->
                                                            <!-- file upload starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'uploadfile'"
                                                              class="flex-item"
                                                            >
                                                              <div class="labelclass">
                                                                {{ newrepeatingFields.label
                                                                }}<sup
                                                                  v-if="
                                                                     newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required') ||
                                                                      newrepeatingFields.validation.includes('REQUIRED')
                                                                  "
                                                                  ><i class="fa fa-asterisk required"></i
                                                                ></sup>
                                                              </div>
                                                              <div class="twoitemflex">
                                                                <input
                                                                  class="form-control"
                                                                  :label="newrepeatingFields.label"
                                                                  type="file"
                                                                />
                                                              </div>
                                                            </div>
                                                            <!-- file upload ends -->
                                                            <!-- year starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'year'"
                                                              class="flex-item"
                                                            >
                                                              <div class="labelclass">
                                                                {{ newrepeatingFields.label
                                                                }}<sup
                                                                  v-if="
                                                                     newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required') ||
                                                                      newrepeatingFields.validation.includes('REQUIRED')
                                                                  "
                                                                  ><i class="fa fa-asterisk required"></i
                                                                ></sup>
                                                              </div>
                                                              <input
                                                                class="form-control"
                                                                :label="newrepeatingFields.label"
                                                                type="number"
                                                                min="1900"
                                                                max="2099"
                                                                step="1"
                                                              />
                                                            </div>
                                                            <!-- year ends -->
                                                            <!-- calculation starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'calculation'"
                                                              class="flex-item"
                                                            >
                                                              <div class="labelclass">
                                                                {{ newrepeatingFields.label }}
                                                              </div>
                                                              {{}}
                                                            </div>
                                                            <!-- calculation ends -->
                                                            <!-- summery starts -->
                                                            <div
                                                              class="ml-2 pb-2 font-15"
                                                              v-else-if="newrepeatingFields.type == 'summary'"
                                                            >
                                                              <i> {{ newrepeatingFields.label }} </i>
                                                            </div>
                                                            <!-- summery ends -->
                                                            <!-- qr code starts -->
                                                            <div
                                                               class="elem"    
                                                               v-else-if="newrepeatingFields.type == 'qrcode'"
                                                            >
                                                                    <div hidden>
                                                                      {{
                                                                        qrcodefun(
                                                                          newrepeatingFields.fieldName,
                                                                          newrepeatingFields.qrData
                                                                        )
                                                                      }}
                                                                    </div>
                                                                    <div class="position-relative">
                                                                    <img
                                                                      class="qrcodeframe"
                                                                      :src="
                                                                        qrcodetxt[newrepeatingFields.fieldName]
                                                                      "
                                                                      title="qr code"
                                                                    />
                                                                    
                                                                    <div class="overlay" @click.prevent="editrepeatedmeasure(newfield)"></div>
                                                                  </div>
                                                            </div>
                                                            <!-- qr code ends -->
                                                            <!-- Grid starts -->
                                                            <div
                                                              class="elem"
                                                              v-else-if="newrepeatingFields.type == 'grid'"
                                                            >
                                                              <div
                                                                v-if="
                                                                  gridoptarray[newrepeatingFields.fieldName] ==
                                                                    undefined
                                                                "
                                                                hidden
                                                              >
                                                                {{
                                                                  gridoptfun(
                                                                    newrepeatingFields.fieldName,
                                                                    newrepeatingFields.options[0]
                                                                  )
                                                                }}
                                                              </div>
                                                              <div
                                                                class="notesstyle gridbackground gridelem"
                                                              >
                                                                <div
                                                                  class="ibox-content-edit flextable gridbackground"
                                                                >
                                                                  <div class="addfieldtable">
                                                                    <div
                                                                      class="rowcolmn"
                                                                      v-for="(gridrow,
                                                                      index) in gridoptarray[
                                                                      newrepeatingFields.fieldName
                                                                      ][0].Rows"
                                                                      :key="gridrow"
                                                                    >
                                                                      <div class="rowlabelgrid">
                                                                        {{ gridrow }}
                                                                      </div>
                                                                      <div
                                                                        class="rowcolmnc"
                                                                        v-for="gridcolumn in gridoptarray[
                                                                          newrepeatingFields.fieldName
                                                                        ][0].Columns"
                                                                        :key="gridcolumn"
                                                                      >
                                                                        <div v-if="index == 0">
                                                                          {{ gridcolumn }}
                                                                        </div>
                                                                        <input
                                                                          class="form-control"
                                                                          v-model="
                                                                            griddata[0].Columns[
                                                                              gridcolumn - 1
                                                                            ]
                                                                          "
                                                                          type="text"
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- Grid ends -->
                                                            <!-- numberanddate starts -->
                                                            <div
                                                              v-else-if="
                                                                newrepeatingFields.type == 'numberanddate'
                                                              "
                                                              class="flex-item"
                                                            >
                                                              <div class="labelclass">
                                                                {{ newrepeatingFields.label
                                                                }}<sup
                                                                  v-if="
                                                                     newrepeatingFields.validation.includes('required') ||
                                                                      newrepeatingFields.validation.includes('Required') ||
                                                                      newrepeatingFields.validation.includes('REQUIRED')
                                                                  "
                                                                  ><i class="fa fa-asterisk required"></i
                                                                ></sup>
                                                              </div>
                                                              <div class="d-flex">
                                                                <input
                                                                  class="form-control"
                                                                  :label="newrepeatingFields.label"
                                                                  type="number"
                                                                />
                                                                <input
                                                                  class="form-control"
                                                                  :label="newrepeatingFields.label"
                                                                  type="date"
                                                                />
                                                              </div>
                                                            </div>
                                                            <!-- numberanddate ends -->
                                                            <!-- subHeader starts -->
                                                            <div
                                                              v-else-if="newrepeatingFields.type == 'subHeader'"
                                                              class="subheadder"
                                                            >
                                                              <h4>{{ newrepeatingFields.label }}</h4>
                                                            </div>
                                                          </div>
                                                        </template>
                                                      </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- repeatedmeasure ends -->
                                </div>
                                </template>
                              </div>
                            </div>
                            <div
                              class="drag-component-block font-weight-bold text-center py-3"
                              v-if="!isformlocked"
                            >
                              {{ $t("navigations.drag elements here") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <!-- test pdf ends -->
            </div>
            <!------ pagination -------->
            <div class="row mx-0">
              <div class="col-lg-12 d-flex justify-content-lg-end px-0 mt-2">
                <v-pagination
                  v-model="pageno"
                  :pages="totalpages"
                  :range-size="1"
                  active-color="#f4f9ff"
                />
              </div>
            </div>
            <!-- pagination ends -->
          </div>
          <!-- Template design elements -->
          <div
            class="col-md-2"
            v-if="
              showForm === true &&
              !isformlocked &&
              rollsprivilages.includes('Designer Tool Create Form')
            "
          >
            <div class="ibox-title-elements text-center p-1">
              <h5>{{ $t("navigations.elements") }}</h5>
            </div>
            <div class="ibox-content-elements p-1">
              <div class="elements_container">
                <div class="elements-margins p-1">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      @click.prevent="openModel()"
                    >
                      <img
                        class="pr-1"
                        src="../../assets/add_page.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.new page") }}</h5>
                    </div>
                  </a>
                </div>

                <div class=" ">
                  <h5 class="px-1 w-100 text-center mt-1">
                    <b>{{ $t("navigations.field alignment") }}</b>
                  </h5>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'addone')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/img/one_col.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.one") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'addtwo')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/img/two_col.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.two") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'addthree')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/img/three_col.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.three") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'addfour')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/img/four_col.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.four") }}</h5>
                    </div>
                  </a>
                </div>
                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'addsix')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/img/six_col.svg"
                        alt="Six column"
                      />
                      <h5 class="font-bold">{{ $t("navigations.six") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="">
                  <h5 class="mx-2 text-center mt-1"><b>{{ $t("navigations.labels") }}</b></h5>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'header')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img class="px-2" src="../../assets/head.svg" alt="" />
                      <h5 class="font-bold">{{ $t("navigations.heading") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'subHeader')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img class="px-2" src="../../assets/sub_hed.svg" alt="" />
                      <h5 class="font-bold">{{ $t("navigations.sub heading") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'summary')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <i class="fa fa-file-text-o" aria-hidden="true"></i>

                      <h5 class="font-bold">{{ $t("navigations.notes/summary") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="">
                  <h5 class="mx-2 text-center mt-1"><b>{{ $t("navigations.controls") }}</b></h5>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'textbox')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/text_box.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.text box") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'dropdown')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/drop_down.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.dropdown") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'radio')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/radio_button.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.radio button") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'checkbox')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/chek_box.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.checkbox") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'date')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img class="px-2" src="../../assets/date.svg" alt="" />
                      <h5 class="font-bold">{{ $t("navigations.date") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'time')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img class="px-2" src="../../assets/time.svg" alt="" />
                      <h5 class="font-bold">{{ $t("navigations.time") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'textarea')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/text_area.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.textarea") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'dateandtime')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/date_time.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.date and time") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'grid')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img class="px-2" src="../../assets/grid.svg" alt="" />
                      <h5 class="font-bold">{{ $t("navigations.grid") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'image')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <input
                        id="fileInput"
                        type="file"
                        class="hiddenfile"
                        accept="image/png, image/jpeg"
                        @change="helloButton"
                      />
                      <img
                        class="px-2"
                        src="../../assets/img_upload.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.image") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'uploadfile')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/upload_file.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.file uploader") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'scales')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img class="px-2" src="../../assets/scales.svg" alt="" />
                      <h5 class="font-bold">{{ $t("navigations.scales") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'year')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img class="px-2" src="../../assets/year.svg" alt="" />
                      <h5 class="font-bold">{{ $t("navigations.year") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'qrcode')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img class="px-2" src="../../assets/qr_code.svg" alt="" />
                      <h5 class="font-bold">{{ $t("navigations.qr code") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'calculation')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <i class="fa fa-calculator" aria-hidden="true"></i>
                      <h5 class="font-bold">{{ $t("navigations.calculation") }}</h5>
                    </div>
                  </a>
                </div>
                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'repeatingfield')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <i
                        class="fa fa-thermometer-quarter"
                        aria-hidden="true"
                      ></i>
                      <h5 class="font-bold">{{ $t("navigations.repeated measures") }}</h5>
                    </div>
                  </a>
                </div>
                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'model')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <i class="fa fa-building-o" aria-hidden="true"></i>

                      <h5 class="font-bold">{{ $t("navigations.option group") }}</h5>
                    </div>
                  </a>
                </div>
                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'numberanddate')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <img
                        class="px-2"
                        src="../../assets/number_date.svg"
                        alt=""
                      />
                      <h5 class="font-bold">{{ $t("navigations.number and date") }}</h5>
                    </div>
                  </a>
                </div>

                <div class="">
                  <h5 class="mx-2 text-center mt-1"><b>{{ $t("navigations.repeated fields") }}</b></h5>
                </div>
                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      @click.prevent="createrepeatedfieldpopup()"
                    >
                      <i class="fa fa-repeat" aria-hidden="true"></i>

                      <h5 class="font-bold">{{ $t("navigations.create repeated fields") }}</h5>
                    </div>
                  </a>
                </div>
                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      draggable="true"
                      @dragstart="drag($event, 'repeatedmodel')"
                      @dragenter.prevent
                      @dragover.prevent
                    >
                      <i class="fa fa-files-o" aria-hidden="true"></i>
                      <h5 class="font-bold">{{ $t("navigations.repeated fields") }}</h5>
                    </div>
                  </a>
                </div>
                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      @click="managerepeatedfieldmodel()"
                    >
                      <i class="fa fa-desktop" aria-hidden="true"></i>

                      <h5 class="font-bold">{{ $t("navigations.manage repeated fields") }}</h5>
                    </div>
                  </a>
                </div>
                <div class="">
                  <h5 class="mx-2 text-center mt-1"><b>{{ $t("navigations.models") }}</b></h5>
                </div>
                
                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      @click="openoptmodel()"
                    >
                      <i class="fa fa-plus-square-o" aria-hidden="true"></i>
                      <h5 class="font-bold">{{ $t("navigations.create option group") }}</h5>
                    </div>
                  </a>
                </div>
                <div class="elements-margins">
                  <a>
                    <div
                      class="widget text-center elements-tools-bg p-1 m-auto"
                      @click="manageoptiongroupmodel()"
                    >
                      <i class="fa fa-briefcase" aria-hidden="true"></i>
                      <h5 class="font-bold">{{ $t("navigations.manage option group") }}</h5>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- modal starts -->
  <!-- design complete starts -->
  <teleport to="#app">
    <div class="add_page_modal_wrapper" v-if="designcompletepopup">
      <div class="option_modal__containers">
        <div
          class="add-block-title d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h4 class="my-0">{{ $t("navigations.design complete") }}</h4>
          <a class="close-link">
            <i
              class="fa fa-times"
              @click.prevent="closedesigncompletemodal()"
            ></i>
          </a>
        </div>

        <div
          class="form-group d-flex flex-column col-lg-10 mx-auto maxheightdesigncomplete"
        >
          <div class="mt-4 form-check">
            <label class="form-check-label ml-4">
              
              {{ $t("navigations.on completing the design means the form is locked and there is no further amendment") }}
            </label>
          </div>
          <div class="mt-4 form-check">
            <input
              type="checkbox"
              v-model="reviewandapprovalvar"
              id="reviewandapproval"
              class="form-check-input"
              @change="handleCheckboxChange()"
            />
            <label class="form-check-label ml-4" for="reviewandapproval">
              
               {{ $t("navigations.send the form to review and approval") }}
            </label>
          </div>

          <div
            v-if="this.versionhistoryarray.length != 1"
            class="mt-4 form-check"
          >
            <input
              type="checkbox"
              v-model="replacetemplatevar"
              id="replacetemplate"
              class="form-check-input"
              :disabled="reviewandapprovalvar"
            />
            <label class="form-check-label ml-4" for="replacetemplate">
              
               {{ $t("navigations.replace the existing template on the visit schedules of the ongoing patients") }}
            </label>
          </div>
          <div
            v-if="this.versionhistoryarray.length != 1"
            class="mt-4 form-check"
          >
            <input
              type="checkbox"
              v-model="exisitingvisitsvar"
              id="exisitingvisits"
              class="form-check-input"
              :disabled="reviewandapprovalvar"
            />
            <label class="form-check-label ml-4" for="exisitingvisits">
             
               {{ $t("navigations.replace the template on the existing study visits") }}
            </label>
          </div>
          <div class="d-flex justify-content-center mt-2">
            <button
              type="button"
              class="btn btn-primary mr-2"
              @click.prevent="closedesigncompletemodal()"
            >
               {{ $t("navigations.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="designcomplete()"
            >
             {{ $t("navigations.design complete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <!-- design complete ends -->
  <!-- repeat measures starts -->
  <teleport to="#app">
    <div class="add_page_modal_wrapper" v-if="repeatedmeasurepopup">
      <div class="option_modal__containers">
        <div
          class="add-block-title d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h4 class="my-0">  {{ $t("navigations.manage repeated measures") }}</h4>
          <a class="close-link">
            <i
              class="fa fa-times"
              @click.prevent="closerepeatedmeasuremodal()"
            ></i>
          </a>
        </div>

        <div class="form-group col-lg-10 textgroup">
          <label for="optionscheckbox">  {{ $t("navigations.id") }}</label>
          <div class="optgroup">
            <input
              type="text"
              class="form-control"
              id="optionscheckbox"
              v-model="repratmeasureid"
              placeholder="options"
            />
          </div>
        </div>
        <div
          class="form-group col-lg-10 mx-auto"
          v-if="!repeatedmeasurelistpopup"
        >
          <div
            v-for="measureopts in repeatedoptions"
            :key="measureopts"
            class="form-group col-lg-10 textgroup"
          >
            <label for="optionscheckbox">{{ measureopts.fieldName }}</label>
            <div class="optgroup">
              <input
                type="text"
                class="form-control"
                v-model="temprepeatedmeasureval[measureopts.fieldName]"
                id="optionscheckbox"
                placeholder="options"
              />
            </div>
          </div>

          <div class="form-group col-lg-10 textgroup">
            <button
              type="button"
              class="btn btn-primary float-right ml-1"
              @click.prevent="addrepeatemesureentries()"
            >
                {{ $t("navigations.add") }}
            </button>
            <button
              type="button"
              class="btn btn btn btn-secondary float-right"
              @click.prevent="repeatedmeasurlist()"
            >
                {{ $t("navigations.back") }}
            </button>
          </div>
        </div>
        <div
          class="form-group d-flex flex-column col-lg-10 mx-auto maxheight"
          v-if="repeatedmeasurelistpopup"
        >
          <div class="table-responsive">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>  {{ $t("navigations.repeated measure name") }}</th>
                  <th class="text-center">  {{ $t("navigations.delete") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in repeatedmeasurevalarray" :key="item.ID">
                  <td>{{ item.ID }}</td>
                  <td class="text-center">
                    <i
                      class="fa fa-trash icon-color"
                      aria-hidden="true"
                      @click="deleterepeatedmeasure(item)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="form-group col-lg-10 mt-auto">
            <button
              type="button"
              class="btn btn-primary mr-2"
              @click.prevent="repeatedmeasurdatapopup()"
            >
                 {{ $t("navigations.add measures") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="saverepeatedmeasurdata()"
            >
               {{ $t("navigations.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <!-- repeat measures ends -->
  <!-- repeat modal starts -->
  <teleport to="#app">
    <div class="add_page_modal_wrapper" v-if="createrepeatedmodel">
      <div class="option_modal__containers">
        <div
          class="add-block-title d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h4 class="my-0"> {{ $t("navigations.manage repeated model") }}</h4>
          <a class="close-link">
            <i class="fa fa-times" @click.prevent="closerepeatingmodel()"></i>
          </a>
        </div>

        <div class="modal-body" v-if="!addrepeatedoptfield">
          <label>{{ $t("navigations.repeated group name") }}</label>

          <input
            id="repeatingGroup"
            v-model="repeatedtemplatename"
            name="repeatingGroup"
            type="text"
            class="form-control required"
            aria-required="true"
          />

          <button
            type="button"
            class="btn btn-default btn-xs mt-3 px-4 w-100"
            @click.prevent="addrepeatedoptionfield()"
          >
            + Add Field
          </button>

          <table class="table table-bordered mt-3 mb-3">
            <thead>
              <tr>
                <th width="80%">Field Name</th>

                <th width="10%" class="text-center">Delete</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(item, index) in repeatedtemplatefieldarray"
                :key="item.formId"
              >
                <td>{{ item.fieldName }}</td>
                <td class="text-center">
                  <i
                    class="fa fa-trash icon-color"
                    aria-hidden="true"
                    @click="removedrepeatedoptions(index)"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="modal-footer" v-if="!addrepeatedoptfield">
          <button
            type="button"
            class="btn btn-primary btn-xs px-4 float-right mr-3"
            @click.prevent="saverepeatedoptions()"
          >
            Save
          </button>
        </div>
        <div class="modal-body" v-if="addrepeatedoptfield">
          <label class="mt-2">Field Name</label>
          <input
            v-model="repeatingfieldname"
            id="fieldName"
            name="fieldName"
            type="text"
            class="form-control required"
            aria-required="true"
          />
          <label class="mt-2">Field Type</label>
          <select
            class="form-control"
            v-model="repeatingtype"
            name="fieldtype"
            id="fieldType"
          >
            <option selected value="" disabled>Select</option>
             <option value="dropdown">dropdown</option>
               <option value="number">number</option>
              <option value="date">date</option>
            <option value="text">text</option>
            <option value="time">time</option>          
            <option value="radio">radio</option>
          </select>
          <div
            v-if="
              repeatingtype == 'radio' ||
                repeatingtype == 'checkbox' ||
                repeatingtype == 'dropdown'
            "
            class="form-group col-lg-12 mx-auto textgroup"
          >
            <label for="optionscheckbox">Add Options</label>
            <div class="optgroup">
              <input
                type="text"
                class="form-control opttext"
                v-model="repeatoptionss"
                placeholder="options"
              />
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="addrepeatedopts()"
              >
                Add
              </button>
            </div>
          </div>
          <div
            v-if="
              repeatingtype == 'radio' ||
                repeatingtype == 'checkbox' ||
                repeatingtype == 'dropdown'
            "
            class="form-group col-lg-12 mx-auto"
          >
            <label for="optionslistcheckbox">Options</label>
            <select multiple class="form-control horizondalscroll">
              <option
                v-for="options in repeatedoptions"
                :key="options"
                disabled
              >
                {{ options }}
              </option>
            </select>
          </div>
        </div>

        <div class="modal-footer" v-if="addrepeatedoptfield">
          <div class="float-right">
            <button
              type="button"
              class="btn btn-default btn-xs px-4 mr-2"
              @click.prevent="cancelrepeatedoptionfield()"
            >
              Back
            </button>
            <button
              type="button"
              class="btn btn-primary btn-xs px-4"
              @click.prevent="addrepeatedoptions()"
            >
              Save Field
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <!-- repeat modal ends -->
  <!-- modal starts -->
  <teleport to="#app">
    <div class="add_page_modal_wrapper" v-if="managerepeatfieldmodel">
      <div class="option_modal__containers">
        <div
          class="add-block-title d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h4 class="my-0">{{ $t("navigations.manage repeated group") }}</h4>
          <a class="close-link">
            <i
              class="fa fa-times"
              @click.prevent="closemanagerepeatmodel()"
            ></i>
          </a>
        </div>

        <div class="form-group col-lg-10 pt-4">
          <div class="table-responsive">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>{{ $t("navigations.repeated group") }}</th>
                  <!-- <th>Edit</th> -->
                  <th class="text-center">{{ $t("navigations.delete") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in presavedrepeatedmodel" :key="item">
                  <td>{{ item.templateName }}</td>
                  <!-- <td class="text-center">
                    <i
                      class="fa fa-edit icon-color"
                      @click.prevent="viewoptiongroup(item.id)"
                    ></i>
                  </td> -->
                  <td class="text-center">
                    <i
                      class="fa fa-trash icon-color"
                      aria-hidden="true"
                      @click="deleterepeatmodel(item.id)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <!-- modal ends -->
  <!-- modal starts -->
  <teleport to="#app">
    <div class="add_page_modal_wrapper" v-if="manageoptoptmodel">
      <div class="option_modal__containers">
        <div
          class="add-block-title d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h4 class="my-0">{{ $t("navigations.manage option group") }}</h4>
          <a class="close-link">
            <i class="fa fa-times" @click.prevent="closemanageoptmodel()"></i>
          </a>
        </div>

        <div class="form-group col-lg-12 textgroup">
          <label for="optionscheckbox">{{ $t("navigations.search") }}</label>
          <div class="optgroup">
            <input
              type="text"
              class="form-control opttext"
              v-model="optiongroupsearch"
              id="optionscheckbox"
              placeholder=""
            />
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="searchoptiongroups()"
            >
             {{ $t("navigations.search") }}
            </button>
          </div>
        </div>
        <div class="form-group col-lg-12 mx-auto">
          <div class="table-responsive">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>{{ $t("navigations.option group") }}</th>
                  <th class="text-center">{{ $t("navigations.edit") }}</th>
                  <th class="text-center">{{ $t("navigations.delete") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in optiongroups.results" :key="item.formId">
                  <td>{{ item.label }}</td>
                  <td class="text-center">
                    <i
                      class="fa fa-edit icon-color"
                      @click.prevent="viewoptiongroup(item.id)"
                    ></i>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-trash icon-color"
                      aria-hidden="true"
                      @click="deleteoptiongroup(item.id)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <!-- modal ends -->
  <!-- modal starts -->
  <teleport to="#app">
    <div class="add_page_modal_wrapper" v-if="showoptmodel">
      <div class="option_modal__containers">
        <div
          class="add-block-title d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h4 class="my-0">{{ $t("navigations.create option group") }}</h4>
          <a class="close-link">
            <i class="fa fa-times" @click.prevent="closeoptmodel()"></i>
          </a>
        </div>
        <div class="p-3">
          <!-- <div class="form-group col-lg-10 mx-auto textgroup"> -->
          <div class="form-group col-lg-12">
            <label for="instructionsdropdown">{{ $t("navigations.option group name") }}</label>
            <input
              type="text"
              class="form-control"
              v-model="optiongroup"
              maxlength="30"
              id="instructionsdropdown"
              placeholder=""
            />
          </div>

          <div class="form-group col-lg-12">
            <label for="instructionsdropdown" class="mr-4">{{ $t("navigations.default type") }}</label>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                value="radio"
                v-model="optiontype"
                type="radio"
                name="flexRadioDefault"
                id="defaultoptiongroup"
              />
              <label class="form-check-label" for="flexRadioDefault1">
                {{ $t("navigations.radio") }}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                value="dropdown"
                v-model="optiontype"
                type="radio"
                name="flexRadioDefault"
                id="defaultoptiongroup"
              />
              <label class="form-check-label" for="flexRadioDefault2">
                {{ $t("navigations.dropdown") }}
              </label>
            </div>
          </div>

          <!--  new code starts-->
          <div class="form-group col-lg-12 textgroup">
            <label for="optionscheckbox">{{ $t("navigations.add options") }}</label>
            <div class="row mb-3">
              <div class="col-lg-3">
                <!-- radiovalues changed to singlemodelvalues below-->
                <label class="mb-0">{{ $t("navigations.code value") }}</label>
              </div>
              <div class="col-lg-9 pl-0 mb-2">
                <input
                  ref="codeValueInput"
                  type="text"
                  class="form-control"
                  v-model="singlemodelvalues"
                  maxlength="50"
                  style="width:100%"
                />
              </div>

              <div class="col-lg-3 pr-0">
                <label class="mb-0">{{ $t("navigations.option name") }}</label>
              </div>
              <div class="col-lg-9 pl-0">
                <!-- radiooptions changed to optiongroupopts below-->
                <input
                  ref="optionNameInput"
                  type="text"
                  class="form-control"
                  v-model="optiongroupopts"
                  id="optionscheckbox"
                  maxlength="50"
                  style="width:100%"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-5">
                <!--addradiooptions() changed to addroptiongroupopts() -->
                <div style="display: flex;">
                  <button
                    type="button"
                    class="save_btn px-3 py-1"
                    @click.prevent="addroptiongroupopts()"
                    v-if="editingOption === null"
                    :disabled="
                      singlemodelvalues == '' ||
                        singlemodelvalues == null ||
                        optiongroupopts == '' ||
                        optiongroupopts == null
                    "
                  >
                    {{ $t("navigations.add") }}
                  </button>
                  <!-- Update button -->
                  <button
                    type="button"
                    class="save_btn px-3 py-1"
                    @click.prevent="UpdateOGoptions()"
                    v-else
                  >
                     {{ $t("navigations.update") }}
                  </button>
                  <div style="margin-left: 10px;"></div>
                  <!-- Cancel button -->
                  <button
                    type="button"
                    class="save_btn px-3 py-1"
                    @click.prevent="cancelEditDropdown()"
                    v-if="editingOption !== null"
                    style="background-color: red; color: white;"
                  >
                      {{ $t("navigations.cancel") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- new codde ends here -->

          <!-- Old add options starts here -->

          <!-- <div class="form-group col-lg-10 mx-auto textgroup">
            <label for="optionscheckbox">Add Options</label>
            <div class="row">
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control"
                  v-model="singlemodelvalues"
                  placeholder="Code value"
                />
              </div>
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control"
                  v-model="optiongroupopts"
                  id="optionscheckbox"
                  placeholder="Option name"
                />
              </div>
              <div class="col-lg-2">
                <button
                  type="button"
                  class="save_btn px-3 py-1"
                  @click.prevent="addroptiongroupopts()"
                  :disabled="
                    singlemodelvalues == '' ||
                      singlemodelvalues == null ||
                      optiongroupopts == '' ||
                      optiongroupopts == null
                  "
                >
                  Add
                </button>
              </div>
            </div>
          </div> -->
          <!--Old add options end here -->
          <!-- new tablestructure below -->
          <div
            class="form-group col-lg-12 textgroup"
            style="overflow-y: auto; max-height: 250px;"
          >
            <!-- old val of table -->
            <!-- v-for="option in radiooptionsarray"
                          :key="option.codevalue" -->
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Code Value</th>
                  <th>Option Name</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="options in groupoptions" :key="options">
                  <td>{{ options.codevalue }}</td>
                  <td>{{ options.optionname }}</td>
                  <td>
                    <i
                      class="fa fa-edit icon-color"
                      style="color: #a13b7c"
                      @click="
                        editOGOptions(options.codevalue, options.optionname);
                        focusOnEdit();
                      "
                    ></i>
                  </td>
                  <td>
                    <i
                      class="fa fa-trash icon-color"
                      style="color: #a13b7c"
                      @click="deleteOGoptions(options.codevalue)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>

            <span class="error-message" v-if="dropdownError"
              >{{ $t("navigations.please add options for the dropdown") }}</span
            >
          </div>

          <!-- new table strcut ends here -->
          <!--Old options select area start here -->
          <!-- <div class="form-group col-lg-10 mx-auto">
            <label for="optionslistcheckbox">Options</label>
            <select
              multiple
              class="form-control horizondalscroll"
              id="exampleFormControlSelect2"
            >
              <option v-for="options in groupoptions" :key="options" disabled>
                ({{ options.codevalue }}){{ options.optionname }}
              </option>
            </select>
          </div> -->
          <!--Old options select area end here -->
          <div class="form-group col-lg-10 mx-auto text-center">
            <button
              v-if="optiongroupeditid != '' && optiongroupeditid != null"
              type="button"
              class="save_btn mb-3"
              @click.prevent="editoptiongroup()"
            >
             {{ $t("navigations.submit") }}
            </button>
            <button
              v-if="optiongroupeditid == '' || optiongroupeditid == null"
              type="button"
              class="save_btn mb-3"
              @click.prevent="creatoptiongroup()"
            >
              {{ $t("navigations.submit") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <!-- modal ends -->
  <!-- modal starts -->
  <teleport to="#app">
    <div class="add_page_modal_wrapper" v-if="showModalll == 1">
      <div class="modal-dialog w-100" style="top: 50px">
        <div class="modal-content">
          <div class="modal-header add-block-title px-3 py-2">
            <h4 class="my-0">{{ $t("navigations.add page") }}</h4>
            <a class="close-link">
              <i class="fa fa-times" @click.prevent="closemodall()"></i>
            </a>
          </div>
          <div v-if="temparray[0].pages.length != 0" class="modal-body">
            <label for="optionscheckbox">{{ $t("navigations.position of new page") }}:</label>
            <select
                      class="form-control"
                      v-model="pageposition"
                      name="fieldtype"
                    >
                      <option value="after">After current page</option>
                      <option value="before">Before current page</option>                      
                      <option value="end">End of form</option>
                    </select>
          </div>
          <div class="modal-body">
            <label for="optionscheckbox">{{ $t("navigations.page name") }}:</label>
            <input
              type="text"
              class="form-control"
              v-model="pagename"
              placeholder=""
              aria-label="Username"
              aria-describedby="basic-addon1"
            />
          </div>
          <div class="modal-footer py-1">
            <button
              type="button"
              class="btn btn-xs py-0 float-right"
              style="color: #ffffff; background-color: #768dd3"
              @click.prevent="createpageinbetween()"
            >
              {{ $t("navigations.submit") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <!-- modal ends -->
  <!-- modal 2 starts -->
  <teleport to="#app">
    <div class="modal__wrapper__component" v-if="componentModal">
      <div class="component__modal__containers">
        <div class="titleclass d-flex justify-content-between py-2 px-3" >
          <h4 class="my-0">{{ $t("navigations.field customization") }}: {{fieldname}}</h4>
          <a class="close-link">
            <i class="fa fa-times" @click.prevent="closemodaltwo()"></i>
          </a>
        </div>
        <div id="modalcontents" class="modalcontents">
          <div class="row mx-0">
            <div class="col-lg-12">
              <!-- textbox starts -->
              <ul class="modal-nav modal-nav-tabs" role="tablist">
                <li >
                  <a
                      href="#tab-1"
                      class="modal-nav-link "
                      :class="{
                          'active-modal-tab': refreshFlags['general'] === true,
                        }"
                      data-toggle="tab"
                      @click="handleTabClick('general')"
                    >
                    {{ $t("navigations.general") }}
                  </a>
                </li>
                <li v-if="inputValidationElements.includes(selectedmenu)">
                  <a
                      href="#tab-2"
                      class="modal-nav-link"
                      :class="{
                        'active-modal-tab': refreshFlags['validation'] === true,
                      }"
                      data-toggle="tab"
                      @click="handleTabClick('validation')"
                    >
                    {{ $t("navigations.validation") }}
                    </a>
                </li>
                <li v-if="inputValidationElements.includes(selectedmenu)">
                  <a
                      href="#tab-3"
                      class="modal-nav-link"
                      :class="{
                        'active-modal-tab': refreshFlags['dependencies'] === true,
                      }"
                      data-toggle="tab"
                      @click="handleTabClick('dependencies')"
                    >
                    {{ $t("navigations.dependencies") }}
                    </a>
                </li >
                <li v-if="selectedmenu=='textbox' || selectedmenu=='text' || selectedmenu=='date'">
                  <a
                      href="#tab-4"
                      class="modal-nav-link"
                      :class="{
                        'active-modal-tab': refreshFlags['calculations'] === true,
                      }"
                      data-toggle="tab"
                      @click="handleTabClick('calculations')"
                    >
                    {{ $t("navigations.calculations") }}
                    </a>
                </li >
              </ul>
              <div class="ibox-tab-content" >
                <div role="tabpanel" v-if="refreshFlags['general']">
                  <div
                v-if="selectedmenu == 'textbox' || selectedmenu == 'text'"
                class="fieldentry"
              >
                <!-- <div class="ibox-modal-title py-1">
                  <h5 class="my-0 mt-2">{{ $t("navigations.text box") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div>
                    <label for="textboxtext">{{ $t("navigations.text box label") }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="labeltext"
                      id="textboxtext"
                      placeholder=""
                      :disabled="isformlocked==true"
                    />
                  </div>
                  <div class="textgroup">
                    <label for="instructionstextbox">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="fieldname"
                      maxlength="30"
                      id="instructionstextbox"
                      placeholder=""
                      :disabled="isformlocked==true"
                    />
                  </div>
                  <div class="textgroup">
                    <label>{{ $t("navigations.validations") }}</label>
                    <Multiselect :disabled="isformlocked==true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      @clear="clearValues"
                      :options="options"
                      :hideSelected="false"
                      :closeOnSelect="false"
                     :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  <div class="form-group col-12 px-0 my-2" v-if="generalValidations.length>0">
                    <div class="ibox-content p-3 mb-2" v-for="(validation,index) in generalValidations" :key="index">
                      <div class="d-flex justify-content-between">
                        <label>Validation for <b>{{ validation.condition }}</b></label>     
                        <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('general',index)">
                          <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                          <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                        </div>
                      </div>
                      <div
                    class="textgroup mb-3"
                     v-if="validation.condition!='' & validation.condition=='CHARACTERLIMITRANGE'"
                  >
                    <div class="optgroup">
                      <div>
                        <label>{{ $t("navigations.min length") }}</label>
                        <input
                          v-model="minlength"
                          min="0"
                          type="number"
                          class="form-control"
                        />
                        <span v-if="rangeErrors[0] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>
                      </div>
                      <div>
                        <label>{{ $t("navigations.max length") }}</label>
                        <input
                          v-model="maxlength"
                          min="0"
                          type="number"
                          class="form-control"
                        />
                        <span v-if="rangeErrors[1] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>
                      </div>
                    </div>
                    <div v-if="rangeErrors[4] || rangeErrors[5]">                    
                      <span class="errormsg" v-if="rangeErrors[4]"
                        >{{ $t("navigations.value entered on min length must be lower than value entered on max length field")}}</span>
                      <span class="errormsg" v-if="rangeErrors[5]"
                        >{{ $t("navigations.value entered on max length cannot be zero")}}</span
                      >
                    </div>
                      </div>
                      <div
                        class="form-group textgroup mb-3"
                        v-if="validation.condition!='' & validation.condition=='NUMERICRANGE'"
                      >
                        <div class="optgroup">
                          <div>
                            <label>{{$t('navigations.min value')}}</label>
                            <input
                              v-model="minvalue" :disabled="isformlocked==true"
                              min="0"
                              type="number"
                              class="form-control"
                            />
                            <span v-if="rangeErrors[2] == true" class="errormsg"> {{ $t("navigations.please enter a value") }}</span>
                          </div>
                          <div>
                            <label>{{$t('navigations.max value')}}</label>
                            <input
                              v-model="maxvalue" :disabled="isformlocked==true"
                              min="0"
                              type="number"
                              class="form-control"
                            />
                            <span v-if="rangeErrors[3] == true" class="errormsg"> {{ $t("navigations.please enter a value") }}</span>
                          </div>
                        </div>
                        <div>                    
                          <span class="errormsg" v-if="rangeErrors[6]"
                            >{{$t("navigations.value entered on min value must be lower than value entered on max value field")}}</span>
                          <span class="errormsg" v-if="rangeErrors[7]"
                            >{{$t("navigations.value entered on max value cannot be zero")}}</span
                          >
                          </div>
                      </div>
                      <div><label :for="`optionRadiosExclusion${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                      <div><label :for="`optionRadiosError${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                      <div><label :for="`optionRadiosWarning${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                      <div><label :for="`optionRadiosInformation${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                      <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][0]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please choose a value") }}
                        </div>
                      <div class="col-12 px-0">
                        <label for="message">{{ $t('navigations.message') }}</label>
                        <textarea class="form-control" v-model="validation.message" :disabled="isformlocked==true" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                        <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][1]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                      </div>     
                    </div>  
                    <div class="px-0">
                    <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                  </div>                  
                  </div>                  
                  </div>
                          
                </div>
            
            
              <!-- textbox ends dropdown -->
              <!-- Grid starts -->
              <div v-if="selectedmenu == 'grid'" class="fieldentry">
                <div class="ibox-title">
                  <h5>{{ $t("navigations.grid") }}</h5>
                  <nav class="nav nav-pills flex-column flex-sm-row">
                    <a
                      :class="gridgeneral"
                      aria-current="page"
                      @click.prevent="selectconf('general')"
                      >{{ $t("navigations.general") }}</a
                    >
                    <a
                      :class="gridconfiguration"
                      @click.prevent="selectconf('configuration')"
                      >{{ $t("navigations.configuration") }}</a
                    >
                  </nav>
                </div>
                <div v-if="gridoption == 'general'" class="ibox-content-edit">
                  <div class="form-group">
                    <label for="textareatext">{{ $t("navigations.grid label") }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="textareatext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionstextarea">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      class="form-control"
                      id="instructionstextarea"
                      placeholder=""
                    />
                  </div>
                </div>
                <div v-if="gridoption == 'configuration'">
                  <div class="ibox-content-edit flextable">
                    <div class="addfieldtable">
                      <div>{{ $t("navigations.row label") }}</div>
                      <!-- <div v-for="repeatingdatas in repeatingdata" :key="repeatingdatas" class="col-md-12 d-flex justify-content-end distancebetween"> -->
                      <div
                        class="rowcolmn"
                        v-for="(gridrow, index) in gridrows"
                        :key="gridrow"
                      >
                        <input
                          class="form-control"
                          v-model="griddata[0].Rows[index]"
                          type="text"
                        />
                        <div v-if="gridrow == 1">
                          <i
                            class="fa fa-plus-square-o iconstyle"
                            aria-hidden="true"
                            @click.prevent="incrementrows()"
                          ></i>
                        </div>
                        <div v-else>
                          <i
                            class="fa fa-times-circle-o closeiconstyle"
                            aria-hidden="true"
                            @click.prevent="removerowsrows(index)"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div class="addfieldtable">
                      <div>{{ $t("navigations.column label") }}</div>
                      <div
                        class="rowcolmn"
                        v-for="(gridcolumn, index) in gridcolumns"
                        :key="gridcolumn"
                      >
                        <input
                          class="form-control"
                          v-model="griddata[0].Columns[index]"
                          type="text"
                        />
                        <div v-if="gridcolumn == 1">
                          <i
                            class="fa fa-plus-square-o iconstyle"
                            aria-hidden="true"
                            @click.prevent="incrementcolumns()"
                          ></i>
                        </div>
                        <div v-else>
                          <i
                            class="fa fa-times-circle-o closeiconstyle"
                            aria-hidden="true"
                            @click.prevent="removecolumns(index)"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-10 rowfieldtype"
                    v-for="(gridrow, index) in gridrows"
                    :key="gridrow"
                  >
                    <label>Field Type of Row {{ gridrow }}</label>
                    <select
                      class="col-md-10 form-control"
                      v-model="griddata[0].Fieldtypes[index]"
                      name="fieldtype"
                    >
                     <option value="date">Date</option>
                     <option value="number">Number</option>
                      <option value="text">Text</option>
                      <option value="time">Time</option>
                    </select>
                  </div>
                </div>

              </div>
              <!-- Grid ends  -->
              <!-- model starts -->
              <div v-if="selectedmenu == 'model'" class="fieldentry">
                <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.option group") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group textgroup">
                    <label class="col-form-label" for="instructionstext"
                      >{{ $t("navigations.select model") }}</label
                    >
                    <select
                      class="form-control horizondalscroll"
                      id="exampleFormControlSelect2"
                      v-model="selectedmodel"
                      @change.prevent="modelchange()"
                    >
                    <option value="" disabled selected>{{ $t("navigations.select") }}</option> 
                      <option
                        v-for="models in optiongroups.results"
                        :value="models"
                        :key="models.id"
                      >
                        {{ models.label }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group textgroup">
                    <label for="optionslistcheckbox">{{ $t("navigations.options") }}</label>
                    <select
                      multiple
                      class="form-control horizondalscroll"
                      id="exampleFormControlSelect2"
                    >
                      <option
                        v-for="options in selectedmodel.groupoptions"
                        :key="options"
                        disabled
                      >
                        ({{ options.codevalue }}){{ options.optionname }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group textgroup">
                    <label for="optionscheckbox">{{ $t("navigations.add options") }}</label>
                    <div class="row">
                      <div class="col-lg-5">
                        <input
                          type="text"
                          class="form-control"
                          v-model="singlemodelvalues"
                          placeholder="Code value"
                          maxlength="50"
                        />
                      </div>
                      <div class="col-lg-5">
                        <input
                          type="text"
                          class="form-control"
                          v-model="singlemodeloptions"
                          id="optionscheckbox"
                          placeholder="Option name"
                          maxlength="50"
                        />
                      </div>
                      <div class="col-lg-2">
                        <button
                          type="button"
                          class="save_btn px-3 py-1"
                          @click.prevent="addmodeloptions()"
                          :disabled="
                            singlemodelvalues == '' ||
                              singlemodelvalues == null ||
                              singlemodeloptions == '' ||
                              singlemodeloptions == null
                          "
                        >
                          {{ $t("navigations.add") }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-form-label" for="modelelem"
                      >{{ $t("navigations.select control type") }}</label
                    >
                    <div class="col-md-12">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          value="radio"
                          v-model="modeloptiontype"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault1"
                        />
                        <label class="form-check-label" for="flexRadioDefault1">
                          {{ $t("navigations.radio") }}
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          value="dropdown"
                          v-model="modeloptiontype"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault2"
                        />
                        <label class="form-check-label" for="flexRadioDefault2">
                          {{ $t("navigations.dropdown") }}
                        </label>
                      </div>
                      <div class="option-error-block" v-if="controlSelectError">
                        {{ $t("navigations.please select a control type") }}
                      </div>
                    </div>
                  </div>
            
                </div>
              </div>
              <!-- model ends -->
              <!-- headding starts -->
              <div v-if="selectedmenu == 'header'" class="fieldentry">
                <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.heading") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label" for="headdingtext"
                        >{{ $t("navigations.add heading") }}</label
                      >
                      <input
                        type="text"
                        v-model="labeltext"
                        class="form-control"
                        id="headdingtext"
                        placeholder=""
                        :disabled="isformlocked==true"
                      />
                    </div>
                  </div>
                  <!-- <div class="form-group textgroup">
                    <label class="col-form-label" for="instructionstext"
                      >Field Name</label
                    >
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionstext"
                      placeholder="Field Name"
                    />
                  </div> -->
                </div>
              </div>
              <!-- headding ends -->
              <!-- subheading starts -->
              <div v-if="selectedmenu == 'subHeader'" class="fieldentry">
                <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.sub heading") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="subheaddingtext">{{ $t("navigations.add sub heading") }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="subheaddingtext"
                      placeholder=""
                      :disabled="isformlocked==true"
                    />
                  </div>
                  <!-- <div class="form-group textgroup">
                    <label for="instructionstext">Field Name</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionstext"
                      placeholder="Field Name"
                    />
                  </div> -->
                </div>
              </div>
              <!-- subheading ends -->
              <!-- dropdown starts -->
              <div v-if="selectedmenu == 'dropdown'" class="fieldentry">
                <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.dropdown") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group row">
                    <div class="col-lg-6">
                      <label for="dropdowntext">{{ $t("navigations.dropdown label") }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="labeltext"
                        id="dropdowntext"
                        placeholder=""
                        :disabled="isformlocked==true"
                      />
                    </div>
                    <div class="col-lg-6">
                      <label for="dropdowntext">{{ $t("navigations.select option group") }}</label>
                      <select
                        class="form-select pb-0 horizondalscroll"
                        id="exampleFormControlSelect2"
                        v-model="selectedmodel"
                        @change.prevent="dropdownmodelchange()"
                        :disabled="isformlocked==true"
                      >
                        <option value="" disabled selected>{{ $t("navigations.select") }}</option> 
                        <option
                          v-for="models in optiongroups.results"
                          :value="models"
                          :key="models.id"
                        >
                          {{ models.label }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group textgroup">
                    <label for="instructionsdropdown">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="fieldname"
                      maxlength="30"
                      id="instructionsdropdown"
                      placeholder=""
                      :disabled="isformlocked==true"
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="optionscheckbox">{{ $t("navigations.add options") }}</label>
                    <div class="row mb-3">
                      <div class="col-lg-3 pr-0">
                        <label class="mb-0">{{ $t("navigations.code value") }}</label>
                      </div>
                      <div class="col-lg-9 pl-0 mb-2">
                        <input
                          ref="codeValueInput"
                          type="text"
                          class="form-control"
                          v-model="radiovalues"
                          maxlength="50"
                          style="width:100%"
                          :disabled="isformlocked==true"
                        />
                      </div>
                      <div class="col-lg-3 pr-0">
                        <label class="mb-0">{{ $t("navigations.option name") }}</label>
                      </div>
                      <div class="col-lg-9 pl-0 mb-2">
                        <input
                          ref="optionNameInput"
                          type="text"
                          class="form-control"
                          v-model="radiooptions"
                          id="optionscheckbox"
                          maxlength="50"
                          style="width:100%"
                          :disabled="isformlocked==true"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-5">
                        <!-- Add button -->
                        <div style="display: flex;">
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="addradiooptions()"
                            v-if="editingOption === null"
                            :disabled="
                                radiovalues == '' || radiovalues == null ||
                                radiooptions == ''|| radiooptions == null "
                          >
                            {{ $t("navigations.add") }}
                          </button>
                          <!-- Update button -->
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="UpdateDropdownoptions()"
                            v-else
                          >
                             {{ $t("navigations.update") }}
                          </button>
                          <div style="margin-left: 10px;"></div>
                          <!-- Cancel button -->
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="cancelEditDropdown()"
                            v-if="editingOption !== null"
                            style="background-color: red; color: white;"
                          >
                             {{ $t("navigations.cancel") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group textgroup"
                    style="overflow-y: auto; max-height: 250px;"
                  >
                    <!-- <label for="optionslistcheckbox">Options</label> -->
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th> {{ $t("navigations.code value") }}</th>
                          <th> {{ $t("navigations.option name") }}</th>
                          <th class="text-center">{{ $t("navigations.edit") }}</th>
                          <th class="text-center">{{ $t("navigations.delete") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="option in radiooptionsarray"
                          :key="option.codevalue"
                        >
                          <td>{{ option.codevalue }}</td>
                          <td>{{ option.optionname }}</td>
                          <td class="text-center">
                            <i
                              class="fa fa-edit icon-color"
                              @click="
                                editOptionsfordropdown(
                                  option.codevalue,
                                  option.optionname
                                );
                                focusOnEdit();
                              "
                            ></i>
                          </td>
                          <td class="text-center">
                            <i
                              class="fa fa-trash icon-color"
                              @click="deleteoptions(option.codevalue)"
                            ></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <span class="error-message" v-if="dropdownError"
                      >{{ $t("navigations.please add options for the dropdown") }}</span
                    >
                  </div>
                  <div class="form-group mb-0 textgroup">
                    <label>{{ $t("navigations.validations") }}</label>
                    <Multiselect :disabled="isformlocked==true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      :options="commonvalidations"
                      @change="valuesChanged()"
                      @select="changeArray"
                        @clear="clearValues"
                       @deselect="deselectedOption"
                      :hideSelected="false"
                      :closeOnSelect="false"
                      :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  <div class="form-group col-12 px-0 my-2" v-if="generalValidations.length>0">
                      <div class="ibox-content p-3 mb-2" v-for="(validation,index) in generalValidations" :key="index">
                        <div class="d-flex justify-content-between">
                          <label>Validation for <b>{{ validation.condition }}</b></label>     
                          <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('general',index)">
                            <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                            <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                          </div>
                        </div>
                        <div><label :for="`optionRadiosExclusion${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                        <div><label :for="`optionRadiosError${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                        <div><label :for="`optionRadiosWarning${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                        <div><label :for="`optionRadiosInformation${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                        <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][0]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please choose a value") }}
                        </div>
                        <div class="col-12 px-0">
                          <label for="message">{{ $t('navigations.message') }}</label>
                          <textarea class="form-control" v-model="validation.message" :disabled="isformlocked==true" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                          <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][1]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                        </div>     
                      </div>  
                    <div class="px-0">
                    <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                  </div>                  
                  </div>   
                </div>
              </div>
              <!-- dropdown ends dropdown -->
              <!-- summary starts -->
              <div v-if="selectedmenu == 'summary'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.summary") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="textboxtext">{{ $t("navigations.summary") }}</label>
                    <textarea
                      class="form-control"
                      v-model="labeltext"
                      id="textboxtext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionstextbox">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="fieldname"
                      id="instructionstextbox"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
              <!-- summary ends  -->
              <!-- date starts -->
              <div v-if="selectedmenu == 'date'" class="fieldentry">
                <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.date") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="datetext">{{ $t("navigations.date label") }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="datetext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionsdate">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionsdate"
                      placeholder=""
                    />
                  </div>
               
                  <div class="form-group mb-0 textgroup">
                    <label>{{ $t("navigations.validations") }}</label>
                    <Multiselect :disabled="isformlocked==true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      :options="generaldateOptions"
                        @clear="clearValues"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :hideSelected="false"
                      :closeOnSelect="false"
                       :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  <div class="form-group col-12 px-0 my-2" v-if="generalValidations.length>0">
                      <div class="ibox-content p-3 mb-2" v-for="(validation,index) in generalValidations" :key="index">
                        <div class="d-flex justify-content-between">
                          <label>Validation for <b>{{ validation.condition }}</b></label>     
                          <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('general',index)">
                            <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                            <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                          </div>
                        </div>
                        <div class="form-group textgroup" v-if="validation && validation.condition=='DATEFORMAT'">
                            <label for="instructionsdate">{{ $t("navigations.date format") }}</label>
                            <div class="input-group">
                              <div class="col-12 px-0">
                                <select class="form-select" v-model="dateFormat">
                                  <option
                                    v-for="date in dateList"
                                    :key="date.dateFormat"
                                    :value="date.dateFormat"
                                  >
                                    {{ date.dateFormat }}
                                  </option>
                                </select>  
                              </div>                 
                            <div class="errormsg" v-if="daterangeErrors[3]"
                                >{{$t("navigations.please select a date format")}}</div
                              >                  
                          </div>                
                          </div>
                          <div class="form-group textgroup row" v-if="validation && validation.condition=='DATERANGE'">
                            <div class="col-12 col-md-6">
                              <label>{{ $t("navigations.min date") }}</label>
                              <input v-model="minDate" :disabled="isformlocked==true" type="date" class="form-control"/>      
                              <span v-if="daterangeErrors[0] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>  
                            </div>
                            <div class="col-12 col-md-6">
                              <label>{{ $t("navigations.max date") }}</label>
                              <input v-model="maxDate" :disabled="isformlocked==true" type="date" class="form-control"/>    
                              <span v-if="daterangeErrors[1] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>    
                            </div>     
                            <div>                    
                              <span class="errormsg" v-if="daterangeErrors[2]"
                                >{{$t("navigations.value entered on min value must be lower than value entered on max value field")}}</span
                              >
                              </div>                     
                          </div>
                        <div><label :for="`optionRadiosExclusion${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                        <div><label :for="`optionRadiosError${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                        <div><label :for="`optionRadiosWarning${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                        <div><label :for="`optionRadiosInformation${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                        <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][0]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please choose a value") }}
                        </div>
                        <div class="col-12 px-0">
                          <label for="message">{{ $t('navigations.message') }}</label>
                          <textarea class="form-control" v-model="validation.message" :disabled="isformlocked==true" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                          <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][1]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                        </div>     
                      </div>  
                    <div class="px-0">
                    <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                  </div>                  
                  </div>   
                </div>
              </div>
              <!-- date ends dropdown -->
              <!-- scales starts -->
              <div v-if="selectedmenu == 'scales'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.scale") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="textboxtext">{{ $t("navigations.scale label") }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="labeltext"
                      id="textboxtext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionstextbox">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="fieldname"
                      maxlength="30"
                      id="instructionstextbox"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group mb-0 textgroup">
                    <label>{{ $t("navigations.validations") }}</label>
                    <Multiselect :disabled="isformlocked==true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      @change="valuesChanged()"
                        @clear="clearValues"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :options="commonvalidations"
                      :hideSelected="false"
                      :closeOnSelect="false"
                       :placeholder="$t('navigations.select validations')"
                    />
                  </div>

                  <div class="form-group textgroup">
                    <div class="optgroup">
                      <div>
                        <label>{{ $t("navigations.min value") }}</label>
                        <input
                          v-model="scaleminval"
                          type="number"
                          class="form-control"
                          @input="clearInput()"
                        />
                        <span class="error-message" v-if="scaleError[2]"
                          >
                          {{ $t("navigations.only accepts digits and minus sign") }}</span
                        >
                      </div>
                      <div>
                        <label>{{ $t("navigations.max value") }}</label>
                        <input
                          v-model="scalemaxval"
                          type="number"
                          class="form-control"
                          @input="clearInput()"
                        />
                        <span class="error-message" v-if="scaleError[3]"
                          >
                         {{ $t("navigations.only accepts digits and minus sign") }}</span
                        >
                      </div>
                    </div>
                    <div>
                      <span class="error-message" v-if="scaleError[0]"
                        >{{ $t("navigations.values entered on min value and max value fields cannot be same") }}</span
                      >
                      <span class="error-message" v-if="scaleError[1]"
                        >
                        {{ $t("navigations.value entered on min value must be lower than value entered on max value field") }}</span
                      >
                    </div>
                  </div>
                  <div class="form-group col-12 px-0 my-2" v-if="generalValidations.length>0">
                      <div class="ibox-content p-3 mb-2" v-for="(validation,index) in generalValidations" :key="index">
                        <div class="d-flex justify-content-between">
                          <label>Validation for <b>{{ validation.condition }}</b></label>     
                          <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('general',index)">
                            <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                            <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                          </div>
                        </div>
                        <div><label :for="`optionRadiosExclusion${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                        <div><label :for="`optionRadiosError${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                        <div><label :for="`optionRadiosWarning${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                        <div><label :for="`optionRadiosInformation${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                        <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][0]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please choose a value") }}
                        </div>
                        <div class="col-12 px-0">
                          <label for="message">{{ $t('navigations.message') }}</label>
                          <textarea class="form-control" v-model="validation.message" :disabled="isformlocked==true" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                          <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][1]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                        </div>     
                      </div>  
                    <div class="px-0">
                    <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                  </div>                  
                  </div>
                </div>
              </div>
              <!-- scale ends  -->
              <!-- calculation starts -->
              <div v-if="selectedmenu == 'calculation'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.calculation") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="calculatedfieldtext">{{ $t("navigations.calculation label") }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="calculatedfieldtext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionscalculated">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      class="form-control"
                      id="instructionscalculated"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionstime">{{ $t("navigations.operations") }}</label>
                     <textarea  class="form-control" v-model="calculate.operations" name="calculation" id="instructionstime"></textarea>
                  </div>
                </div>
              </div>
              <!-- calculation ends  -->
              <!-- time starts -->
              <div v-if="selectedmenu == 'time'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.time") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="timetext">{{ $t("navigations.time label") }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="timetext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionstime">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      class="form-control"
                      id="instructionstime"
                      placeholder=""
                    />
                  </div>
                 
                  <div class="form-group mb-0 textgroup">
                    <label>{{ $t("navigations.validations") }}</label>
                    <Multiselect :disabled="isformlocked==true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                        @clear="clearValues"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :options="generaltimeOptions"
                      :hideSelected="false"
                      :closeOnSelect="false"
                       :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  <div class="form-group col-12 px-0 my-2" v-if="generalValidations.length>0">
                      <div class="ibox-content p-3 mb-2" v-for="(validation,index) in generalValidations" :key="index">
                        <div class="d-flex justify-content-between">
                          <label>Validation for <b>{{ validation.condition }}</b></label>     
                          <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('general',index)">
                            <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                            <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                          </div>
                        </div>
                        <div class="form-group textgroup" v-if="validation && validation.condition=='TIMEFORMAT'">
                          <label for="instructionstime">{{ $t("navigations.time format") }}</label>
                          <select class="form-select" v-model="timeFormat">
                            <option value="hh:mm:ss tt">{{ $t("navigations.12 hrs") }}</option>
                            <option value="HH:mm:ss">{{ $t("navigations.24 hrs") }}</option>
                          </select>
                          <span class="errormsg" v-if="timerangeErrors[3]"
                              >{{$t("navigations.please select a time format")}}</span
                            >
                        </div>
                      <div class="form-group textgroup row" v-if="validation && validation.condition=='TIMERANGE'">
                          <div class="col-12 col-md-6">
                            <label>{{ $t("navigations.min time") }}</label>
                            <input v-model="minTime" :disabled="isformlocked==true" type="time" class="form-control" step="1"/>      
                            <span v-if="timerangeErrors[0] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>  
                          </div>
                          <div class="col-12 col-md-6">
                            <label>{{ $t("navigations.max time") }}</label>
                            <input v-model="maxTime" :disabled="isformlocked==true" type="time" class="form-control" step="1"/>    
                            <span v-if="timerangeErrors[1] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>    
                          </div>     
                          <div>                    
                            <span class="errormsg" v-if="timerangeErrors[2]"
                              >{{$t("navigations.value entered on min value must be lower than value entered on max value field")}}</span
                            >
                            </div>                     
                        </div>
                        <div><label :for="`optionRadiosExclusion${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                        <div><label :for="`optionRadiosError${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                        <div><label :for="`optionRadiosWarning${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                        <div><label :for="`optionRadiosInformation${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                        <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][0]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please choose a value") }}
                        </div>
                        <div class="col-12 px-0">
                          <label for="message">{{ $t('navigations.message') }}</label>
                          <textarea class="form-control" v-model="validation.message" :disabled="isformlocked==true" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                          <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][1]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                        </div>     
                      </div>  
                    <div class="px-0">
                    <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                  </div>                  
                  </div>
                </div>
              </div>
              <!-- time ends  -->
              <!-- number and date starts -->
              <div v-if="selectedmenu == 'numberanddate'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.number and date") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="numberanddatetext">{{ $t("navigations.number and date label") }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="numberanddatetext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionsnumberanddate">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionsnumberanddate"
                      placeholder=""
                    />
                  </div>
                                            
                
                  <div class="form-group mb-0 textgroup">
                    <label>{{ $t("navigations.validations") }}</label>
                    <Multiselect :disabled="isformlocked==true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      @clear="clearValues"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :options="generalnumberanddateOptions"
                      :hideSelected="false"
                      :closeOnSelect="false"
                       :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  <div class="form-group col-12 px-0 my-2" v-if="generalValidations.length>0">
                      <div class="ibox-content p-3 mb-2" v-for="(validation,index) in generalValidations" :key="index">
                        <div class="d-flex justify-content-between">
                          <label>Validation for <b>{{ validation.condition }}</b></label>     
                          <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('general',index)">
                            <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                            <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                          </div>
                        </div>
                        <div class="form-group textgroup row"  v-if="validation && validation.condition=='NUMERICRANGE'">
                      <div class="col-12 col-md-6">
                        <label>{{ $t("navigations.min number") }}</label>
                        <input v-model="minvalue" :disabled="isformlocked==true" min="0" type="number" class="form-control"/>    
                        <span v-if="rangeErrors[2] == true" class="errormsg"> {{ $t("navigations.please enter a value") }}</span>    
                      </div>
                      <div class="col-12 col-md-6">
                        <label>{{ $t("navigations.max number") }}</label>
                        <input v-model="maxvalue" :disabled="isformlocked==true" min="0" type="number" class="form-control"/>        
                        <span v-if="rangeErrors[3] == true" class="errormsg"> {{ $t("navigations.please enter a value") }}</span>
                      </div>     
                    <div>                    
                      <span class="errormsg" v-if="rangeErrors[6]"
                        >{{$t("navigations.value entered on min value must be lower than value entered on max value field")}}</span>
                      <span class="errormsg" v-if="rangeErrors[7]"
                        >{{$t("navigations.value entered on max value cannot be zero")}}"</span
                      >
                      </div>
                        </div>     
                        <div
                          class="textgroup"
                          v-if="values.length != 0 && (validation.condition=='lengthrange' || validation.condition=='LENGTHRANGE' || validation.condition=='CHARACTERLIMITRANGE')"
                        >
                          <div class="optgroup">
                            <div>
                              <label>{{ $t("navigations.min length") }}</label>
                              <input
                                v-model="minlength"
                                min="0"
                                type="number"
                                class="form-control"
                              />
                              <span v-if="rangeErrors[0] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>
                            </div>
                            <div>
                              <label>{{ $t("navigations.max length") }}</label>
                              <input
                                v-model="maxlength"
                                min="0"
                                type="number"
                                class="form-control"
                              />
                              <span v-if="rangeErrors[1] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>
                            </div>
                          </div>
                        </div>
                        <div class="form-group textgroup" v-if="validation && validation.condition=='DATEFORMAT'">
                          <label for="instructionsdate">{{ $t("navigations.date format") }}</label>
                          <div class="input-group">
                            <div class="col-12 px-0">
                              <select class="form-select" v-model="dateFormat">
                                <option
                                  v-for="date in dateList"
                                  :key="date.dateFormat"
                                  :value="date.dateFormat"
                                >
                                  {{ date.dateFormat }}
                                </option>
                              </select>   
                            </div>                    
                          <div class="errormsg" v-if="daterangeErrors[3]"
                              >{{ $t('navigations.please select a date format') }}</div
                            >                 
                        </div> 
                      </div>
                        <div class="form-group textgroup row" v-if="validation && validation.condition=='DATERANGE'">
                          <div class="col-12 col-md-6">
                            <label>{{$t("navigations.min date")}}</label>
                            <input v-model="minDate" :disabled="isformlocked==true" type="date" class="form-control"/>      
                            <span v-if="daterangeErrors[0] == true" class="errormsg">{{$t("navigations.please enter a value")}} </span>  
                          </div>
                          <div class="col-12 col-md-6">
                            <label>{{$t("navigations.max date")}}</label>
                            <input v-model="maxDate" :disabled="isformlocked==true" type="date" class="form-control"/>    
                            <span v-if="daterangeErrors[1] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>    
                          </div>     
                          <div>                    
                            <span class="errormsg" v-if="daterangeErrors[2]"
                              >{{$t("navigations.value entered on min value must be lower than value entered on max value field")}}</span
                            >
                            </div>                     
                        </div>       
                        <div><label :for="`optionRadiosExclusion${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                        <div><label :for="`optionRadiosError${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                        <div><label :for="`optionRadiosWarning${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                        <div><label :for="`optionRadiosInformation${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                        <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][0]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please choose a value") }}
                        </div>
                        <div class="col-12 px-0">
                          <label for="message">{{$t('navigations.message')}}</label>
                          <textarea class="form-control" v-model="validation.message" :disabled="isformlocked==true" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                          <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][1]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                        </div>     
                      </div>  
                    <div class="px-0">
                    <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                  </div>                  
                  </div>
                </div>
              </div>
              <!-- number and date ends  -->
              <!--uploadfile  starts -->
              <div v-if="selectedmenu == 'uploadfile'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.upload file") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="datetext">{{$t("navigations.upload file label")}}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="datetext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionsdate">{{$t("navigations.field name")}}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionsdate"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group mb-0 textgroup">
                    <label>{{$t("navigations.validations")}}</label>
                    <Multiselect :disabled="isformlocked==true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      :options="commonvalidations"
                      :hideSelected="false"
                      :closeOnSelect="false"
                       :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                </div>
              </div>
              <!-- uploadfile ends  -->
              <!-- qrcode starts qrcode -->
              <div v-if="selectedmenu == 'qrcode'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.qr code") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="qrcodetext">{{$t("navigations.qr code label")}}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="qrcodetext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionsyear">{{$t("navigations.field name")}}<sup><i class="fa fa-asterisk required"></i></sup></label>

                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionsyear"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label> {{$t("navigations.qr code data")}}<sup><i class="fa fa-asterisk required"></i></sup></label>
                    <textarea
                      class="form-control"
                      v-model="qrcodecontents"
                      id="qrcodecontents"
                      placeholder=""
                    />
                    <span v-if="emptyField" class="error-message"
                      >{{ $t("navigations.please fill the qr data") }}</span
                    >
                  </div>
                </div>
              </div>
              <!-- qrcode ends  -->
              <!-- radiobutton starts -->
              <div v-if="selectedmenu == 'radio'" class="fieldentry">
                <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.radio") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group row">
                    <div class="col-lg-6">
                      <label for="radiotext">{{ $t("navigations.radio label") }}</label>
                      <input
                        type="text"
                        v-model="labeltext"
                        class="form-control"
                        id="radiotext"
                        placeholder=""
                      />
                    </div>
                    <div class="col-lg-6">
                      <label for="dropdowntext">{{ $t("navigations.select option group") }}</label>
                      <select
                        class="form-select select-padding horizondalscroll"
                        id="exampleFormControlSelect2"
                        v-model="selectedmodel"
                        @change.prevent="dropdownmodelchange()"
                      >
                        <option value="" disabled selected>{{ $t("navigations.select") }}</option> 
                        <option
                          v-for="models in optiongroups.results"
                          :value="models"
                          :key="models.id"
                        >
                          {{ models.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionsradio">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionsradio"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label>{{ $t("navigations.alignment") }}</label>
                    <select
                      v-model="radioorientation"
                      @change="handleChange"
                      class="form-control"
                      aria-label="Default select example"
                    >
                      <option value="horizontal">Horizontal</option>
                      <option value="vertical">Vertical</option>
                    </select>
                  </div>
                  <div class="form-group textgroup">
                    <label for="optionscheckbox">{{ $t("navigations.add options") }}</label>
                    <div class="row mb-3">
                      <div class="col-lg-3 pr-0">
                        <label class="mb-0">{{ $t("navigations.code value") }}</label>
                      </div>
                      <div class="col-lg-9 mb-2">
                        <input
                          ref="codeValueInput"
                          type="text"
                          class="form-control"
                          v-model="radiovalues"
                          maxlength="50"
                        />
                      </div>
                      <div class="col-lg-3 pr-0">
                        <label class="mb-0">{{ $t("navigations.option name") }}</label>
                      </div>
                      <div class="col-lg-9">
                        <input
                          type="text"
                          ref="optionNameInput"
                          class="form-control"
                          v-model="radiooptions"
                          id="optionscheckbox"
                          maxlength="50"
                        />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-5">
                        <!-- Add button  -->
                        <div style="display: flex;">
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="addradiooptions()"
                            v-if="editingOption === null"
                            :disabled="
                              radiovalues == '' ||
                                radiovalues == null ||
                                radiooptions == '' ||
                                radiooptions == null
                            "
                          >
                            {{ $t("navigations.add") }}
                          </button>
                          <!-- Update button -->
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="UpdateDropdownoptions()"
                            v-else
                          >
                             {{ $t("navigations.update") }}
                          </button>
                          <div style="margin-left: 10px;"></div>
                          <!-- Cancel button -->
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="cancelEditDropdown()"
                            v-if="editingOption !== null"
                            style="background-color: red; color: white;"
                          >
                             {{ $t("navigations.cancel") }}

                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group textgroup"
                      style="overflow-y: auto; max-height: 250px;"
                    >
                      <!-- <label for="optionslistcheckbox">Options</label> -->
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>{{ $t("navigations.code value") }}</th>
                            <th>{{ $t("navigations.option name") }}</th>
                            <th class="text-center">{{ $t("navigations.edit") }}</th>
                            <th class="text-center">{{ $t("navigations.delete") }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="option in radiooptionsarray"
                            :key="option.codevalue"
                          >
                            <td>{{ option.codevalue }}</td>
                            <td>{{ option.optionname }}</td>
                            <td class="text-center">
                              <i
                                class="fa fa-edit icon-color"
                                @click="
                                  editOptionsfordropdown(
                                    option.codevalue,
                                    option.optionname
                                  );
                                  focusOnEdit();
                                "
                              ></i>
                            </td>
                            <td class="text-center">
                              <i
                                class="fa fa-trash icon-color"
                                @click="deleteoptions(option.codevalue)"
                              ></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <span class="error-message" v-if="dropdownError"
                        >{{ $t("navigations.please add options for the radio") }}</span
                      >
                    </div>
                    <div class="form-group mb-0 textgroup">
                      <label>{{ $t("navigations.validations") }}</label>
                      <Multiselect :disabled="isformlocked==true"
                        class="multiselect-theme"
                        mode="multiple"
                        v-model="values"
                        @change="valuesChanged()"
                          @clear="clearValues"
                        @select="changeArray"
                        @deselect="deselectedOption"
                        :options="commonvalidations"
                        :hideSelected="false"
                        :closeOnSelect="false"
                        :placeholder="$t('navigations.select validations')"
                      />
                    </div>
                    <div class="form-group col-12 px-0 my-2" v-if="generalValidations.length>0">
                      <div class="ibox-content p-3 mb-2" v-for="(validation,index) in generalValidations" :key="index">
                        <div class="d-flex justify-content-between">
                          <label>Validation for <b>{{ validation.condition }}</b></label>     
                          <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('general',index)">
                            <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                            <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                          </div>
                        </div>
                        <div><label :for="`optionRadiosExclusion${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                        <div><label :for="`optionRadiosError${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                        <div><label :for="`optionRadiosWarning${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                        <div><label :for="`optionRadiosInformation${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                        <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][0]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please choose a value") }}
                        </div>
                        <div class="col-12 px-0">
                          <label for="message">{{ $t('navigations.message') }}</label>
                          <textarea class="form-control" v-model="validation.message" :disabled="isformlocked==true" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                          <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][1]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                        </div>     
                      </div>  
                    <div class="px-0">
                    <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                  </div>                  
                  </div>     
                  </div>
                </div>
              </div>
              <!-- radiobutton ends  -->
              <!-- add survey starts -->
              <div v-if="selectedmenu == 'addsurvey'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.add survey") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="timetext">{{ $t("navigations.add survey label") }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="timetext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionstime">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionstime"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
              <!-- add survey ends  -->
              <!-- repeatedmeasure starts  -->
              <div v-if="selectedmenu == 'repeatedmeasure'" class="fieldentry">
                <div class="ibox-title">
                  <h5>{{ $t("navigations.repeated measures") }}</h5>
                </div>
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="repeatedmeasuretext"
                      >{{ $t("navigations.repeated measure label") }}</label
                    >
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="repeatedmeasuretext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionsrepeatedmeasure">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionsrepeatedmeasure"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group">
                    <label>{{ $t("navigations.select repeated model") }}</label>

                    <select
                      class="col-md-10 form-control"
                      v-model="selectedrepeatedtemp"
                      name="fieldtype"
                    >
                      <option selected value="" disabled>Select</option>
                      <option
                        v-for="repeatedoption in presavedrepeatedmodel"
                        :key="repeatedoption.id"
                        :value="repeatedoption.field"
                      >
                        {{ repeatedoption.templateName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- repeatedmeasure ends  -->
              <!-- repeatedmodel starts  -->
              <div v-if="selectedmenu == 'repeatedmodel'" class="fieldentry">
                <div class="ibox-title">
                  <h5> {{ $t("navigations.repeated model") }}</h5>
                </div>
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label>{{ $t("navigations.select repeated model") }}</label>

                    <select
                      class="col-md-10 form-control"
                      v-model="selectedrepeatedtemp"
                      name="fieldtype"
                    >
                     <option value="" disabled v-if="!selectedrepeatedtemp">Select</option>
                      <option
                      aria-placeholder="test"
                        v-for="repeatedoption in presavedrepeatedmodel"
                        :key="repeatedoption.id"
                        :value="repeatedoption.field"
                      >
                        {{ repeatedoption.templateName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- repeatedmodel ends  -->
              <!-- year starts  -->
              <div v-if="selectedmenu == 'year'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.year") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="yeartext">{{ $t("navigations.year label") }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="yeartext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionsyear">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionsyear"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group mb-0 textgroup">
                    <label>{{ $t("navigations.validations") }}</label>
                    <Multiselect :disabled="isformlocked==true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                        @clear="clearValues"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :options="generalyearOptions"
                      :hideSelected="false"
                      :closeOnSelect="false"
                       :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  <div class="form-group col-12 px-0 my-2" v-if="generalValidations.length>0">
                      <div class="ibox-content p-3 mb-2" v-for="(validation,index) in generalValidations" :key="index">
                        <div class="d-flex justify-content-between">
                          <label>Validation for <b>{{ validation.condition }}</b></label>     
                          <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('general',index)">
                            <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                            <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                          </div>
                        </div>
                          <div class="form-group textgroup row" v-if="validation && validation. condition=='YEARRANGE'">
                      <div class="col-12 col-md-6">
                        <label>{{ $t("navigations.min year") }}</label>
                        <input type="number" min="1900" max="2024" v-model="minYear" @keydown="preventNonNumericKeys" class="form-control" @input="validateMinYear"/>      
                        <span v-if="yearrangeError[0] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>    
                      </div>
                      <div class="col-12 col-md-6">
                        <label>{{ $t("navigations.max year") }}</label>
                        <input type="number" min="1900" max="2024" @keydown="preventNonNumericKeys" v-model="maxYear" class="form-control" @input="validateMaxYear"/>   
                        <span v-if="yearrangeError[1] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>       
                      </div>        
                      <div>                    
                        <span class="errormsg" v-if="yearrangeError[2]"
                          >{{$t("navigations.value entered on min year must be lower than value entered on max year field")}}</span
                        >
                        <span class="errormsg" v-if="yearrangeError[3]"
                          >{{$t("navigations.value entered on max year cannot be zero")}}</span
                        >
                        </div>                      
                          </div>     
                        <div><label :for="`optionRadiosExclusion${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                        <div><label :for="`optionRadiosError${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                        <div><label :for="`optionRadiosWarning${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                        <div><label :for="`optionRadiosInformation${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                        <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][0]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please choose a value") }}
                        </div>
                        <div class="col-12 px-0">
                          <label for="message">{{ $t('navigations.message') }}</label>
                          <textarea class="form-control" v-model="validation.message" :disabled="isformlocked==true" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                          <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][1]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                        </div>     
                      </div>  
                    <div class="px-0">
                    <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                  </div>                  
                  </div>   
                </div>
              </div>
              <!-- year ends  -->
              <!-- dateandtime starts -->
              <div v-if="selectedmenu == 'dateandtime'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.date and time") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="timetext">{{ $t("navigations.date and time label") }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="timetext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionstime">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionstime"
                      placeholder=""
                    />
                  </div>
                 
                  <div class="form-group mb-0 textgroup">
                    <label>{{ $t("navigations.validations") }}</label>
                    <Multiselect :disabled="isformlocked==true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                        @clear="clearValues"
                      :options="generaldateandtimeOptions"
                      :hideSelected="false"
                      :closeOnSelect="false"
                      :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  <div class="form-group col-12 px-0 my-2" v-if="generalValidations.length>0">
                      <div class="ibox-content p-3 mb-2" v-for="(validation,index) in generalValidations" :key="index">
                        <div class="d-flex justify-content-between">
                          <label>Validation for <b>{{ validation.condition }}</b></label>     
                          <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('general',index)">
                            <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                            <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                          </div>
                        </div>
                        <div class="form-group textgroup" v-if="validation && validation.condition=='DATEFORMAT'">
                    <label for="instructionsdate">{{ $t("navigations.date format") }}</label>
                    <div class="input-group">
                      <div class="col-12 px-0">
                        <select class="form-select" v-model="dateFormat">
                          <option
                            v-for="date in dateList"
                            :key="date.dateFormat"
                            :value="date.dateFormat"
                          >
                            {{ date.dateFormat }}
                          </option>
                        </select>        
                      </div>                  
                    <div class="errormsg" v-if="daterangeErrors[3]"
                        >{{ $t('navigations.please select a date format') }}</div
                      >                 
                    </div>  
                        </div>             
                        <div class="form-group textgroup row" v-if="validation && validation.condition=='DATERANGE'">
                            <div class="col-12 col-md-6">
                              <label>{{ $t("navigations.min date") }}</label>
                              <input v-model="minDate" :disabled="isformlocked==true" type="date" class="form-control"/>      
                              <span v-if="daterangeErrors[0] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>  
                            </div>
                            <div class="col-12 col-md-6">
                              <label>{{ $t("navigations.max date") }}</label>
                              <input v-model="maxDate" :disabled="isformlocked==true" type="date" class="form-control"/>    
                              <span v-if="daterangeErrors[1] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>    
                            </div>     
                            <div>                    
                              <span class="errormsg" v-if="daterangeErrors[2]"
                                >{{$t("navigations.value entered on min value must be lower than value entered on max value field")}}</span
                              >
                              </div>                     
                          </div>                
                          <div class="form-group textgroup" v-if="validation && validation.condition=='TIMEFORMAT'">
                            <label for="instructionstime">{{ $t("navigations.time format") }}</label>
                            <select :disabled="isformlocked==true" class="form-select" v-model="timeFormat">
                              <option value="hh:mm:ss tt">{{ $t("navigations.12 hrs") }}</option>
                              <option value="HH:mm:ss">{{ $t("navigations.24 hrs") }}</option>
                            </select>
                            <span class="errormsg" v-if="timerangeErrors[3]"
                                >{{$t("navigations.please select a time format")}}</span
                              >
                          </div>
                          <div class="form-group textgroup row" v-if="validation && validation.condition=='TIMERANGE'">
                            <div class="col-12 col-md-6">
                              <label>{{ $t("navigations.min time") }}</label>
                              <input v-model="minTime" :disabled="isformlocked==true" type="time" step="1" class="form-control"/>      
                              <span v-if="timerangeErrors[0] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>  
                            </div>
                            <div class="col-12 col-md-6">
                              <label>{{ $t("navigations.max time") }}</label>
                              <input v-model="maxTime" :disabled="isformlocked==true" type="time" step="1" class="form-control"/>    
                              <span v-if="timerangeErrors[1] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>    
                            </div>     
                            <div>                    
                              <span class="errormsg" v-if="timerangeErrors[2]"
                                >{{$t("navigations.value entered on min value must be lower than value entered on max value field")}}</span
                              >
                              </div>                     
                          </div>   
                        <div><label :for="`optionRadiosExclusion${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                        <div><label :for="`optionRadiosError${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                        <div><label :for="`optionRadiosWarning${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                        <div><label :for="`optionRadiosInformation${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                        <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][0]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please choose a value") }}
                        </div>
                        <div class="col-12 px-0">
                          <label for="message">{{ $t('navigations.message') }}</label>
                          <textarea class="form-control" v-model="validation.message" :disabled="isformlocked==true" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                          <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][1]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                        </div>     
                      </div>  
                    <div class="px-0">
                    <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                  </div>                  
                  </div>   
                </div>
              </div>
              <!-- dateandtime ends  -->
              <!-- image starts -->
              <div v-if="selectedmenu == 'image'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.image") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="textareatext">{{ $t("navigations.image label") }}</label>
                    <textarea
                      rows="4"
                      cols="50"
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="textareatext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionstextarea">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      class="form-control"
                      id="instructionstextarea"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup displayimage">
                    <div class="image-preview">
                      <img
                        @click="onFileeditchange()"
                        v-if="!isedit"
                        class="preview"
                        :src="imageData"
                      />
                      <img
                        @click="onFileeditchange()"
                        v-if="isedit"
                        class="templatepreview"
                        :src="
                          `${fileuploadurl}/file/${
                            imagid.split(',')[0]
                          }?versionid=${imagid.split(',')[1]}`
                        "
                      />
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
              <!-- image ends  -->
              <!-- checkbox starts -->
              <div v-if="selectedmenu == 'checkbox'" class="fieldentry">
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.checkbox") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="checkboxtext">{{ $t("navigations.checkbox label") }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="checkboxtext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionscheckbox">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      class="form-control"
                      id="instructionscheckbox"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group mb-0 textgroup">
                    <label>{{ $t("navigations.validations") }}</label>
                    <Multiselect :disabled="isformlocked==true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                        @clear="clearValues"
                      @change="valuesChanged()"
                      @select="changeArray"
                       @deselect="deselectedOption"
                      :options="commonvalidations"
                      :hideSelected="false"
                      :closeOnSelect="false"
                      :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  <div class="form-group col-12 px-0 my-2" v-if="generalValidations.length>0">
                      <div class="ibox-content p-3 mb-2" v-for="(validation,index) in generalValidations" :key="index">
                        <div class="d-flex justify-content-between">
                          <label>Validation for <b>{{ validation.condition }}</b></label>     
                          <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('general',index)">
                            <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                            <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                          </div>
                        </div>
                        <div><label :for="`optionRadiosExclusion${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                        <div><label :for="`optionRadiosError${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                        <div><label :for="`optionRadiosWarning${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                        <div><label :for="`optionRadiosInformation${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                        <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][0]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please choose a value") }}
                        </div>
                        <div class="col-12 px-0">
                          <label for="message">{{ $t('navigations.message') }}</label>
                          <textarea class="form-control" v-model="validation.message" :disabled="isformlocked==true" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                          <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][1]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                        </div>     
                      </div>  
                    <div class="px-0">
                    <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                  </div>                  
                  </div>   
                </div>
              </div>
              <!-- checkbox ends  -->
              <!-- textarea starts -->
              <div v-if="selectedmenu == 'textarea'" class="fieldentry">
                <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.textarea") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="textareatext">{{ $t("navigations.textarea label") }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="textareatext"
                      placeholder=""
                      :disabled="isformlocked==true"
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionstextarea">{{ $t("navigations.field name") }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionstextarea"
                      placeholder=""
                      :disabled="isformlocked==true"
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label>Validations</label>
                    <Multiselect :disabled="isformlocked==true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      @change="valuesChanged()"
                        @clear="clearValues"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :options="generaltextareaOptions"
                      :hideSelected="false"
                      :closeOnSelect="false"
                       :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  <div class="form-group col-12 px-0 my-2" v-if="generalValidations.length>0">
                      <div class="ibox-content p-3 mb-2" v-for="(validation,index) in generalValidations" :key="index">
                        <div class="d-flex justify-content-between">
                          <label>Validation for <b>{{ validation.condition }}</b></label>     
                          <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('general',index)">
                            <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                            <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                          </div>
                        </div>
                        <div
                    class="textgroup mb-2"
                    v-if="validation && (validation.condition=='lengthrange' || validation.condition=='LENGTHRANGE') || validation.condition=='CHARACTERLIMITRANGE'"
                  >
                    <div class="optgroup">
                      <div>
                        <label>{{ $t("navigations.min length") }}</label>
                        <input
                          v-model="minlength"
                          min="0"
                          type="number"
                          class="form-control"
                        />
                        <span v-if="rangeErrors[0] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>
                      </div>
                      <div>
                        <label>{{ $t("navigations.max length") }}</label>
                        <input
                          v-model="maxlength"
                          min="0"
                          type="number"
                          class="form-control"                         
                        />
                        <span v-if="rangeErrors[1] == true" class="errormsg">{{ $t("navigations.please enter a value") }} </span>
                      </div>
                    </div>
                    <div>                    
                      <span class="errormsg" v-if="rangeErrors[4]"
                        >{{$t("navigations.value entered on min length must be lower than value               entered on max length field")}}</span>
                      <span class="errormsg" v-if="rangeErrors[5]"
                        >{{$t("navigations.value entered on max length cannot be zero")}}</span
                      >
                      </div>

                  </div>   
                        <div><label :for="`optionRadiosExclusion${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                        <div><label :for="`optionRadiosError${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                        <div><label :for="`optionRadiosWarning${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                        <div><label :for="`optionRadiosInformation${index}`"><input  class="mr-1" type="radio" v-model="validation.messageType" :disabled="isformlocked==true" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                        <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][0]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please choose a value") }}
                        </div>
                        <div class="col-12 px-0">
                          <label for="message">{{ $t('navigations.message') }}</label>
                          <textarea class="form-control" v-model="validation.message" :disabled="isformlocked==true" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                          <div v-if="generalValidationsError && generalValidationsError [index] && generalValidationsError [index][1]==true" class="errormsg py-1 mx-0">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                        </div>     
                      </div>  
                    <div class="px-0">
                    <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                  </div>                  
                  </div>   
                </div>
              </div>
              <!-- textarea ends  -->
              <!-- add values menu ends -->
                </div>
                <div role="tabpanel" v-if="refreshFlags['validation']"
                >
                  <div class="row mt-5 text-center" v-if="isformlocked==true && exclusionMessages.length==0">
                   <h5> {{ $t('navigations.no validations added') }}</h5>
                  </div>      
                  <div v-for="(messages,index) in exclusionMessages" :key="index">
                    <div class="d-flex justify-content-between align-items-center mb-4">
                    <h5 class="mb-0">{{$t('navigations.validation message')}}</h5>
                    <div class="position-relative cursor-pointer" v-if="isformlocked==false" @click.prevent="deleteMessage('custom',index)">
                      <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                      <div class="tool-tip">{{ $t('navigations.delete validation') }}</div>
                    </div>
                    </div>
                    <div class="row mx-0" :class="{'mb-2': exclusionMessages.length>1}">                    
                    <div class="form-group col-12 col-md-6 pl-0 pr-1" v-if="this.inputValidationElements.includes(selectedmenu)">
                      <label for="fieldSelect">  {{$t('navigations.if the field is')}}</label>                      
                      <select
                          :disabled="isformlocked==true"
                          id="fieldSelect"
                          v-model="messages.condition"
                          @change=setDate(index,messages.condition)
                          class="study-select select-padding"
                        >
                          <option
                            v-for="(conditions,index) in conditionsArray"
                            :key="index"
                            :value="conditions.value"
                          >
                            {{ conditions.label }}
                          </option>
                        </select>
                        <div v-if="exclusionMessagesError && exclusionMessagesError[index] && exclusionMessagesError[index][0]" class="errormsg">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                    </div>
                    <div class="form-group col-12 col-md-6 pl-1 pr-0" v-if="this.inputValidationElements.includes(selectedmenu)">
                      <label v-if="selectedmenu!='checkbox'" for="fieldValue">  {{$t('navigations.value is')}}</label>  
                      <template v-if="selectedmenu=='year'">                        
                        <input   :disabled="isformlocked==true" type="number" @keydown="preventNonNumericKeys" @input="validateYearInput(messages.value[0],index)"  v-model="messages.value[0]"  class="form-control" id="fieldValue" name="year" min="1000" max="2100" step="1">
                      </template>
                      <template v-if="selectedmenu=='date'">  
                          <input   :disabled="isformlocked==true" type="date" v-model="messages.value[0]" id="fieldValue" class="form-control">                                    
                      </template>
                      <template v-if="selectedmenu=='radio' || selectedmenu=='dropdown'">  
                          <select   :disabled="isformlocked==true" v-model="messages.value[0]" id="fieldValue"  class="form-select"> 
                              <option
                                v-for="option in radiooptionsarray"
                                :value="option.optionname"
                                :key="option.optionname"
                              >
                                {{ option.optionname }}
                              </option>            
                          </select>      
                      </template>
                      <template v-if="selectedmenu!='date' && selectedmenu!='year' && selectedmenu!='radio' && selectedmenu!='dropdown'  && selectedmenu!='checkbox'">
                        <input   :disabled="isformlocked==true" type="text" v-model="messages.value[0]" id="fieldValue" class="form-control">
                      </template>
                      <div v-if="exclusionMessagesError && exclusionMessagesError[index] && exclusionMessagesError[index][3]" class="errormsg mx-0 py-1">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                    </div>
                    <div class="form-group col-12 px-0">
                      <div>
                        <label>{{$t('navigations.show')}}</label>                  
                        <div><label :for="`optionRadiosExclusion${index}`"><input    :disabled="isformlocked==true" class="mr-1" type="radio" v-model="messages.messageType" :value="`Exclusion`" :id="`optionRadiosExclusion${index}`"/><span class="mr-1">{{$t('navigations.exclusion(blocks further data entry)')}}</span></label><img class="mb-1" src="../../assets/img/exclusion.png"/></div>
                        <div><label :for="`optionRadiosError${index}`"><input    :disabled="isformlocked==true" class="mr-1" type="radio" v-model="messages.messageType" :value="`Alert`" :id="`optionRadiosError${index}`"/><span class="mr-1">{{$t('navigations.error(prevents saving that field value)')}}</span></label><img class="mb-1" src="../../assets/img/alert.png"/></div>
                        <div><label :for="`optionRadiosWarning${index}`"><input    :disabled="isformlocked==true" class="mr-1" type="radio" v-model="messages.messageType" :value="`Warning`" :id="`optionRadiosWarning${index}`"/><span class="mr-1">{{$t('navigations.warning')}}</span></label><img class="mb-1" src="../../assets/img/warning.png"/></div>
                        <div><label :for="`optionRadiosInformation${index}`"><input    :disabled="isformlocked==true" class="mr-1" type="radio" v-model="messages.messageType" :value="`Information`" :id="`optionRadiosInformation${index}`"/><span class="mr-1">{{$t('navigations.information')}}</span></label><img class="mb-1" src="../../assets/img/info.png"/></div>
                      </div>   
                      <div v-if="exclusionMessagesError && exclusionMessagesError[index] && exclusionMessagesError[index][1]" class="errormsg mx-0 py-1">
                         {{ $t("navigations.please choose a value") }}
                        </div>                 
                    </div>
                    <div class="form-group col-12 px-0">
                      <label for="message">{{ $t('navigations.message') }}</label>
                      <textarea  :disabled="isformlocked==true" class="form-control" v-model="messages.message" placeholder="Message" id="message"  minlength="10" spellcheck="true"></textarea>
                      <div v-if="exclusionMessagesError && exclusionMessagesError[index] && exclusionMessagesError[index][2]" class="errormsg mx-0 py-1">
                         {{ $t("navigations.please enter a value") }}
                        </div>
                    </div>                  
                    </div>
                    
                  </div>
                  <div class="px-0" v-if="isformlocked==false">
                    <button type="button" @click.prevent="addValidation('custom')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button>
                  </div>
                </div>
                <div role="tabpanel" v-if="refreshFlags['dependencies']">
                  <div v-if="isformlocked==false" class="d-flex justify-content-between align-items-center mb-4">
                    <h5 class="mb-0">{{$t('navigations.select a field to show based on the condition of this field')}}</h5>
                  </div>
                  <div class="row" v-if="isformlocked==false">
                    <div class="form-group">
                      <div><label><input :disabled="isformlocked==true" class="mr-1" type="radio" v-model="selectedOption" name="confirmationOptions" @change="changetoDefault()" value="yes" id="confitrmationRad1"/><span class="mr-1">{{$t('navigations.yes')}}</span></label></div>
                      <div><label><input :disabled="isformlocked==true" class="mr-1" type="radio" v-model="selectedOption" name="confirmationOptions" @change="changetoDefault()" value="no" id="confitrmationRad2"/><span class="mr-1">{{$t('navigations.no')}}</span></label></div>
                    </div>                      
                  </div>        
                  <div class="row mt-5 text-center" v-if="isformlocked==true && dependencies.length==0">
                   <h5>{{ $t('navigations.no dependencies added') }} </h5>
                  </div>          
                  <div class="row mx-0" v-if="selectedOption=='yes'">   
                    <h5 v-if="isformlocked==false" class="px-0">{{ $t('navigations.select field') }}</h5>   
                    <div class="ibox-content row p-3 mb-2 mx-0" v-for="(dependency,index) in dependencies" :key="dependency">   
                               
                      <div class="form-group col-12 pl-0 pr-1">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                           <label class="mb-0" for="fieldSelect">  {{$t('navigations.form')}}</label> 
                           <div v-if="isformlocked==false" class="position-relative cursor-pointer"  @click.prevent="deleteMessage('dependencies',index)">       
                            <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                            <div class="tool-tip">{{ $t('navigations.delete dependency') }}</div>
                           </div> 
                          </div>      
                        <select
                            :disabled="isformlocked==true"
                            id="fieldSelect"
                            v-model="dependency.targetTemplateId"
                            @change.prevent="getFields(dependency.targetTemplateId.templateId,dependency.targetTemplateId.version,index)"
                            class="study-select select-padding"
                          >
                            <option
                              v-for="form in formList"
                              :key="form.templateId"
                              :value="form"
                            >
                              {{ form.templateName }}&nbsp;&nbsp;({{form.version}})
                            </option>
                          </select>
                          <div v-if="dependencyMessagesError && dependencyMessagesError[index] && dependencyMessagesError[index][0]" class="errormsg mx-0 py-1">
                         {{ $t("navigations.please choose a value") }}
                        </div>                 
                      </div>                   
                      <div class="form-group col-12 pl-0 pr-1">
                          <label class="dependency d-flex" for="fieldSelect">  {{$t('navigations.field')}} <div><img class="px-1 mb-1" src="../../assets/img/info.png"/> <span class="tool-tip">{{ $t("navigations.set this field to show based on the condition of the parent field") }}</span></div></label>                                 
                        <select
                            :disabled="isformlocked==true"
                            id="fieldSelect"                           
                            v-model="dependency.visibilityfieldname"
                            class="study-select select-padding"
                          >
                          <option
                              v-for="field in fieldNames[index]"
                              :key="field.fieldName"
                              :value="field"
                            >
                              {{ field.fieldName }}
                            </option>
                          </select>
                          <div v-if="dependencyMessagesError && dependencyMessagesError[index] && dependencyMessagesError[index][1]==true" class="errormsg py-1 mx-0">
                          {{ $t("navigations.please choose a value") }}
                          </div>
                      </div>
                      <label class="px-0" for="">{{$t('navigations.Display the chosen field when the field value matches')}}</label>
                      <div class="form-group col-12 col-md-6 pl-0 pr-1">
                        <select
                        :disabled="isformlocked==true"
                            id="fieldSelect"
                            v-model="dependency.condition"
                            class="study-select select-padding"
                          >
                            <option
                              v-for="(condition,index) in selectedConditionsArray"
                              :key="index"
                              :value="condition.value"
                            >
                              {{ condition.label }}
                            </option>
                          </select>
                          <div v-if="dependencyMessagesError && dependencyMessagesError[index] && dependencyMessagesError[index][2]==true" class="errormsg py-1 mx-0">
                          {{ $t("navigations.please choose a value") }}
                          </div>
                      </div>
                      <div class="form-group col-12 col-md-6 pl-1 pr-1">
                        <template v-if="selectedmenu=='year'">                        
                          <input :disabled="isformlocked==true" type="number" @keydown="preventNonNumericKeys" @input="validatedependencyYearInput(dependency.value,$event,index)"  v-model="dependency.value"  class="form-control" id="fieldValue" name="year" min="1700" max="2900" step="1" placeholder="YYYY">
                          <div v-if="dependencyMessagesError && dependencyMessagesError[index] && dependencyMessagesError[index][3]==true" class="errormsg py-1 mx-0">
                          {{ $t("navigations.please choose a value") }}
                          </div>
                        </template> 
                        <template v-if="selectedmenu=='date'">  
                            <input :disabled="isformlocked==true" type="date" v-model="dependency.value" id="fieldValue" class="form-control">                
                            <div v-if="dependencyMessagesError && dependencyMessagesError[index] && dependencyMessagesError[index][3]==true" class="errormsg py-1 mx-0">
                          {{ $t("navigations.please enter a value") }}
                          </div>
                        </template>
                        <template v-if="selectedmenu=='radio' || selectedmenu=='dropdown' ||selectedmenu=='radiohorizondal'">
                          <select :disabled="isformlocked==true"                   
                            id="fieldSelect"
                            v-model="dependency.value"
                            class="study-select select-padding"
                          >
                            <option
                              v-for="option in selectedConditionValues"
                              :value="option.optionname"
                              :key="option.optionname"
                            >
                            {{ option.optionname }}
                            </option>
                          </select>
                          <div v-if="dependencyMessagesError && dependencyMessagesError[index] && dependencyMessagesError[index][3]==true" class="errormsg py-1 mx-0">
                          {{ $t("navigations.please choose a value") }}
                          </div>
                        </template>
                        <template v-if="selectedmenu!='date' && selectedmenu!='time' && selectedmenu!='year' && selectedmenu!='radio' && selectedmenu!='radiohorizondal' && selectedmenu!='dropdown' && selectedmenu!='checkbox'">
                          <input :disabled="isformlocked==true" type="text" class="form-control" v-model="dependency.value">
                          <div v-if="dependencyMessagesError && dependencyMessagesError[index] && dependencyMessagesError[index][3]==true" class="errormsg py-1 mx-0">
                          {{ $t("navigations.please enter a value") }}
                          </div>
                        </template>
                      </div>
                        <div class="form-group px-0 mb-0">
                      <label >
                      {{$t('navigations.visibility')}}
                      </label>
                      <div class="d-flex">
                        <div class="mr-2"><label :for="`optionRadioDependencyTrue${index}`"><input  class="mr-1" :disabled="isformlocked==true" type="radio" v-model="dependency.isVisible"  :value="true" :id="`optionRadioDependencyTrue${index}`"/><span class="mr-1">{{$t('navigations.true')}}</span></label></div>
                        <div><label :for="`optionRadioDependencyFalse${index}`"><input  class="mr-1" type="radio" :disabled="isformlocked==true" v-model="dependency.isVisible"  :value="false" :id="`optionRadioDependencyFalse${index}`"/><span class="mr-1">{{$t('navigations.false')}}</span></label></div>
                        </div>     
                        <div v-if="dependencyMessagesError && dependencyMessagesError[index] && dependencyMessagesError[index][4]==true" class="errormsg py-1 mx-0">
                          {{ $t("navigations.please choose a value") }}
                          </div>                 
                      </div>          
                      </div>
                    <div class="px-0" v-if="isformlocked==false">
                    <button type="button" @click.prevent="addValidation('dependencies')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add dependency') }}</button>
                  </div>
                  </div>
               
                </div>
                <div role="tabpanel" v-if="refreshFlags['calculations']">
                  <div class="row mt-5 text-center" v-if="isformlocked==true && calculationsArray.length==0">
                   <h5> {{ $t('navigations.no calculations added') }}</h5>
                  </div>          
                  <div class="ibox-content px-3 py-1 mb-2" v-for="(calc,index) in calculationsArray" :key="calc"> 
                    <div class="d-flex justify-content-end mb-2">
                      <div v-if="isformlocked==false" class="position-relative cursor-pointer" @click.prevent="deleteMessage('calculations',index)">       
                        <img width="17" src="../../assets/delete_doc.png" alt="delete message">
                        <div class="tool-tip">{{ $t('navigations.delete calculations') }}</div>
                      </div> 
                    </div>
                    <div class="form-group col-12 pl-0 pr-1">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                          <label class="mb-0" for="fieldSelect">  {{$t('navigations.form')}}</label>              
                      </div>      
                      <select
                          :disabled="isformlocked==true"
                          id="fieldSelect"
                          v-model="calculationTemplateId[index]"
                          @change.prevent="getCalculationFields(calculationTemplateId[index].templateId,calculationTemplateId[index].version,index)"
                          class="study-select select-padding"
                        >
                          <option
                            v-for="form in formList"
                            :key="form.templateId"
                            :value="form"
                          >
                            {{ form.templateName }}&nbsp;&nbsp;({{form.version}})
                          </option>
                        </select>
                        <div v-if="dependencyMessagesError && dependencyMessagesError[index] && dependencyMessagesError[index][0]" class="errormsg mx-0 py-1">
                        {{ $t("navigations.please choose a value") }}
                      </div>                 
                    </div>                   
                    <textarea :disabled="isformlocked==true" class="form-control mb-1" :id="`calculationField-${index}`" v-model="calc.expression"  @input="handleInput($event,calc.expression,index)"
                    @keydown="handleKeydown" placeholder="Use @ to select a fieldname." minlength="10"></textarea>
                    <div v-if="calculationMessagesError && calculationMessagesError[index] && calculationMessagesError[index][0]" class="errormsg mx-0">
                         {{ $t("navigations.please enter an expression") }}
                        </div>
                    <ul v-if="showSuggestions[index]" class="suggestions">
                      <li
                        v-for="(field, fieldIndex) in filteredFields"
                        :key="fieldIndex"
                        @click="selectSuggestion(field,calc.expression,index)"
                      >
                        {{ field }}
                      </li>
                    </ul>
                    <div class="text-right py-1" v-if="showValidate[index]==true">
                      <button  type="button" @click.prevent="inputFields(calc.expression,index)" class="save_btn py-1 px-4"  >
                        {{ $t("navigations.validate") }}
                      </button>
                    </div>       
                    <div class="validation-block" v-if="showValidate[index]==false">
                      <div class="form-group row">
                        <div class="col-3" v-for="(item,rindex) in dynamicFields[index]" :key="rindex">
                          <label :for="`${item}-label`">{{item}}</label>
                          <input  type="text" class="form-control" :id="`${item}-label`">
                        </div>
                      </div>
                      <div class="text-right">
                        <button type="button" @click.prevent="inputFields(calc.expression,index)" class="save_btn py-1 px-4"  >
                          {{ $t("navigations.validate") }}
                        </button>
                      </div>
                  
                    </div>             
                  </div>
                  <div class="px-0" v-if="isformlocked==false">
                    <button type="button" @click.prevent="addValidation('calculations')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add calculation') }}</button>
                  </div>
                </div>
            </div>
            </div>
          </div>
        </div>
        <div class="modalfooter">
          <div class="my-2 row" v-if="selectedmenu!='repeatedmeasure' && selectedmenu!='repeatedmodel' && selectedmenu!='model'">
            <div class="col-md-12 d-flex justify-content-end">
              <button v-if="isformlocked==false" type="button" :disabled="loadingBlock" :class="{ 'disabled-btn': loadingBlock === true }" @click.prevent="deletecomponent()" class="cancel_btn py-1 px-4 mr-2">
                <span>{{ $t("navigations.delete") }}</span>
                <!-- <div class="tool-tip">{{ $t("navigations.delete") }}</div> -->
              </button>
              <button  type="button" :disabled="loadingBlock" :class="{ 'disabled-btn': loadingBlock === true }" @click.prevent="editfield()" class="save_btn py-1 px-4"  v-if="isedit && isformlocked==false">
                <div v-if="loadingBlock" 
                  ><img
                    src="../../assets/img/loading.webp"
                    width="15"
                    class="loading-btn-img"
                    alt="Waiting for login"
                /></div>
                <div v-else >{{ $t("navigations.save") }}</div>
                <!-- <div class="tool-tip">{{ $t("navigations.save") }}</div> -->
              </button>
              <button type="button" :disabled="loadingBlock" :class="{ 'disabled-btn': loadingBlock === true }" @click.prevent="addfield(selectedmenu)" class="save_btn py-1 px-4" v-if="!isedit && isformlocked==false">
                <div v-if="loadingBlock ==true"
                  ><img
                    src="../../assets/img/loading.webp"
                    width="15"
                    class="loading-btn-img"
                    alt="Waiting for login"
                /></div>
                <div v-else>{{ $t("navigations.add") }}</div>
                <!-- <div class="tool-tip">{{ $t("navigations.add") }}</div> -->
              </button>            
            </div>
          </div>
          <div class="my-2 row" v-if="selectedmenu=='model'">
            <div class="col-md-12 d-flex justify-content-end">
            <button type="button" :disabled="loadingBlock" :class="{ 'disabled-btn': loadingBlock === true }" @click.prevent="deletecomponent()" class="cancel_btn py-1 px-4 mr-2">
              <div v-if="loadingBlock==true"
                  ><img
                    src="../../assets/img/loading.webp"
                    width="15"
                    class="loading-btn-img"
                    alt="Waiting for login"
                /></div>
              <div v-else>{{ $t("navigations.delete") }}</div>
              <!-- <div class="tool-tip">{{ $t("navigations.delete") }}</div> -->
            </button>
            <button type="button" @click.prevent="addmodel()" class="save_btn py-1 px-4" v-if="isedit">
              <div v-if="loadingBlock==true"
                  ><img
                    src="../../assets/img/loading.webp"
                    width="15"
                    class="loading-btn-img"
                    alt="Waiting for login"
                /></div>
              <div v-else>{{ $t("navigations.save") }}</div>
              <!-- <div class="tool-tip">{{ $t("navigations.save") }}</div> -->
            </button>
          </div>
          </div>
          <div class="my-2 row" v-if="selectedmenu=='repeatedmeasure'">
            <div class="col-md-12 d-flex justify-content-end">
              <button type="button" @click.prevent="addrepeatedmeasure()" class="save_btn py-1 px-4" v-if="isedit">
                <div>{{ $t("navigations.save") }}</div>
                <!-- <div class="tool-tip">{{ $t("navigations.save") }}</div> -->
              </button>
            </div>
          </div>
          <div class="my-2 row" v-if="selectedmenu=='repeatedmodel'">
            <div class="col-md-12 d-flex justify-content-end">
              <button type="button" @click.prevent="addrepeatedmeasure()" class="save_btn py-1 px-4" v-if="isedit">
                <span>{{ $t("navigations.save") }}</span>
                <!-- <div class="tool-tip">{{ $t("navigations.save") }}</div> -->
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <!-- modal ends -->
  <!-- <teleport to="#app">
   <div class="loader-block" v-if="loader">
    <span>Loading...</span>
   </div>
  </teleport> -->
  <createrepeatedfield
    v-if="repeatedfieldpopup"
    :isformlocked="isformlocked"
    :formName="formname"
    :repfieldstoedit="repfieldstoedit"
    :popuptype="popuptype"
    :feildNames = "fieldnamesarray"
    :calculationFields = "calculationFieldNames"
    :templateId = "templateid"
    @repeatedmodelclose="closerepeatedfield()"
    @send-object="handleReceivedObject"
    @removeRField = "removeRepeatingField"
  >
  </createrepeatedfield>
  <createnewversion
    v-if="creatversionpopup == true"
    @closedialogebox="closecreatenewversion()"
    @createnewtempversion="newtemplateversion()"
    :currentversion="currentformversion"
    :formid="newversionformid"
    :therapeuticAreaId="localTherapeuticId"
    :formCategoryId="localFormCategoryId"
  >
  </createnewversion>
  <!-- modal 3 starts -->
  <teleport to="#app">
    <createFormModal
      v-if="showCreateFormModal"
      @closeModal="(showCreateFormModal = false), getForms()"
      @SubmitForm="createtemplate()"
      @sendIdToParent="handleIdFromChild"
      :templateList="listforms"
      :studyId="$store.getters.getStudyIs"
    />
  </teleport>
  <teleport to="#app">
    <addnewrandomcolumn
      v-if="addnewgrouppoopup"
      @closeModal="(addnewgrouppoopup = false)"
      @addnewgroup="addnewgroupwithdetails"
      :studyId="$store.getters.getStudyIs"
    />
  </teleport>
</template>

<script src="./form_design.js"></script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
@import "../../assets/style.css";
@import "./style1.css";
@import "./modal.css";
.error-message {
  color: #ff0000;
}
.makeitbottom {
  position: absolute;
  bottom: 8px;
  right: 8px;
}
.gridelem {
  overflow: auto;
}
.element-block {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
.drag-component-block {
  border: 1px dashed #c2b6b6;
  font-size: 20px;
  color: #ada9a9;
  background-color: #ffffff;
}
.multiselect-theme {
  --ms-radius: 0;
  --ms-py: 0.4rem;
  --ms-option-font-size: 0.8rem;
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}
.form-control {
  font-size: 0.8rem;
}
.activeBackground {
  background-color: #dddddd;
}
.bgblue {
  background-color: #f0f0ff;
}
.max-height-500 {
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.side-popup {
  text-align: left;
  left: -166px !important;
  width: 170px !important;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  -moz-box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  -webkit-box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5) !important;
  z-index: 200;
}

.side-popup > *:is(:hover, :focus) {
  background-color: #e4eaf9;
}

.expand-delete-block:is(:hover, :focus) {
  border-radius: 50%;
  background-color: #dddddd;
}

.max-height-0 {
  max-height: 0;
}

.max-height-30 {
  max-height: 300px;
}

.template-list li {
  overflow: hidden;
  transition: max-height 0.2s ease-out, padding-block 0.2s ease-out;
}

.add_page_modal_wrapper,
.modal__wrapper__component {
    position: fixed;
    inset: 0;
    background: rgb(0 0 0 / 18%);
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
    z-index: 3000;
    align-items: center;
    top: 0;
    left: 0;
}


.add_page {
  width: min(400px, 90%);
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  height: 150px;
}
.option_modal__containers {
  width: min(600px, 90%);
  background: #fff;
  border-radius: 4px;
  overflow: auto;
  min-height: 316px;
  position: fixed;
  margin-top: 100px;
  max-height: 400px;
}

.component__modal__containers {
  width: min(500px, 90%);
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  margin-top:10px;
  /* height:calc(100vh - 20px); */
  max-height:calc(100dvh - 20px);
}

.maincontainer {
  min-height: 50px;
}

.ibox-content-elements {
  background-color: #c4cfff;
  padding: 0px;
  border-color: #dedede;
  border-image: none;
  border-radius: 0px;
  border-style: solid;
  border-width: 0px;
  padding-top: 3px;
  padding-bottom: 5px;
}

.ibox-modal-title {
  background-color: #eeedff;
  border-color: #e7eaec;
  -o-border-image: none;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px;
  color: inherit;
  padding: 15px 15px 8px 15px;
  min-height: 40px;
  position: relative;
  clear: both;
  width: unset;
}

.ibox-modal-title h5 {
  display: inline-block;
  font-size: 14px;
  margin: 0 0 7px;
  padding: 0;
  text-overflow: ellipsis;
  color: #676a6c;
}

.ibox-content-elements h5 {
  font-size: 10px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.updatebutton {
  width: 100%;
  padding: 20px;
}

.updatebtn {
  float: right;
}

.deletepagebtn {
  float: left;
}

.btncenter {
  margin: auto;
}

.groupcontents {
  width: 100%;
  padding: 20px;
}

.opttext {
  width: 80%;
}

.optgroup {
  display: flex;
  gap: 5px;
}
.selectzindex {
  z-index: 10000;
}
.addcontainer {
  width: 100%;
}

.outline-add {
  color: green;
  font-size: 14px;
  font-weight: bold;
  margin-left: 25px;
}

.outline-add:hover,
.outline-delete:hover {
  cursor: pointer;
}

.placebuttons {
  display: flex;
  margin-right: 0px;
  margin-left: 220px;
}

.textflex {
  display: flex;
}

.outline-delete {
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.fieldentry {
  background-color: #ffffff;
}

.textgroup {
  margin-top: 10px;
}

.settingsmenu {
  width: 300px;
  background-color: #ffffff;
}

.mainmenuitem {
  margin-bottom: 1px;
  font-weight: 600;
  padding: 0px 20px 0px 20px;
}

.submenuitem {
  border-top: 0px solid #ffffff;
  background-color: #eeedff;
  width: 100%;
  border-bottom: 1px solid #d0d4df;
}

.submenuitem:hover {
  cursor: pointer;
}

a {
  text-decoration: none !important;
}

.dropdown {
  height: 100%;
}

.maincontents {
  background-color: white;
  height: 100%;
}

.home {
  background-color: #f3f3f4;
  min-height: 100vh;
  display: flex;
}

.navbar-static-side {
  background-color: #e6e5ea;
}

.metismenu {
  width: 220px;
}

.text-right {
  text-align: end;
}

.ibox-content-edit-toolbar {
  position: relative;
  background-color: #fff;
  padding: 10px 20px 10px 20px;
  border-color: #dedede;
  border-image: none;
  border-radius: 0px;
  border-style: solid;
  border-width: 1px;
}
.dropdownbackground {
  background-color: #fff !important;
}
.ibox-content-edit {
  background-color: #ffffff;
  padding: 5px;
  border-color: #80ced7;
  -o-border-image: none;
  border-image: none;
  border-style: solid;
  border-width: 0px;
  display: flex;
  flex-direction: column;
}

.icon-layout {
  float: right;
  line-height: 1.5;
}

.nav-label {
  font-weight: 600;
}

.checkboxcontainer {
  width: fit-content;
  min-width: 15%;
}

.labelclass {
  text-align: left;
  font-size: 13px;
  font-weight: 600;
}

.dummydata:is(:active, :focus) {
  background-color: #cbd2eb;
}
.columtable {
  border: 1px solid #c2b6b6;
  border-collapse: collapse;
  height: 30px;
  margin-bottom: 10px;
}

.btnwidth {
  min-width: 50px;
  background-color: #5f64a3;
  border-color: #5f64a3;
}

.btnwidth:hover {
  min-width: 50px;
  background-color: #5f64a3;
  border-color: #5f64a3;
}
.rowcolmnc {
  min-width: 60px;
}
.titleclass {
  color: #ffffff;
  background: #768dd3;
  z-index: 2000;
}

.add-block-title {
  color: #ffffff;
  background: #768dd3;
}

.firstmodalheight {
  height: 38% !important;
}

.ibox-title {
  background-color: #eeedff;
  border-color: #e7eaec;
  -o-border-image: none;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px;
  color: inherit;
  padding: 12px 15px 8px 15px;
  min-height: 40px;
  position: relative;
  clear: both;
  width: unset;
}

.ibox-title h5 {
  display: inline-block;
  font-size: 14px;
  margin: 0 0 7px;
  padding: 0;
  text-overflow: ellipsis;
  color: #676a6c;
}

.savebutton {
  font-size: 20px;
  color: black !important;
  margin-right: 16px !important;
}

.savebutton :hover {
  color: #7aa6ff !important;
}

.deletebutton {
  font-size: 20px;
  color: black !important;
  margin-right: 16px !important;
}

.deletebutton :hover {
  color: red !important;
}

.version {
  width: 85px;
  border-color: #dedede;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.resizemodel {
  width: min(200px, 90%);
}

.addpage {
  width: 100% !important;
}

.addpagewrapper {
  margin-top: 30px !important;
}

.headerheight {
  min-height: 50px;
}

.tooldisplay {
  display: flex !important;
}

.versionbox {
  margin-top: 5px;
}

.pointer {
  visibility: hidden;
  width: max-content;
  background-color: #ec4758;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 0;
  top: -35px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.rowcolmn {
  margin-top: 0px;
  display: flex;
  gap: 5px;
  margin: 10px;
}
.rowlabelgrid {
  margin-top: auto;
}
.ibox-title-elements {
  color: #ffffff !important;
  text-transform: uppercase;
  padding-block: 0.56rem;
  background-color: #768dd3;
  border-color: #dedede;
  border-image: none;
  border-style: solid solid none;
  border-width: 0px;
  margin-bottom: 0;
  min-height: 30px;
  position: relative;
  clear: both;
  -webkit-border-radius: 3px 3px 0 0;
  -moz-border-radius: 3px 3px 0 0;
  border-radius: 0px;
}

.ibox-title-elements h5 {
  font-size: 0.8rem !important;
}

.elements-tools-bg {
  width: 100px;
  background-color: #ffffff;
  color: #676a6c;
  border: 1px solid #e7eaec;
  cursor: pointer;
}

.element-tools-title {
  font-size: 0.75rem;
}
.elements-margins {
  margin-top: 3px;
  margin-bottom: 3px;
}
.elements-margins-large {
  margin: 0px -9px 0px 1px !important;
  padding: 0px 12px 0px 8px !important;
}

.close-link {
  color: white;
}
.horizondalscroll {
  overflow-x: auto;
  max-height: 500px;
}
.save_btn {
  background-color: #6a97e7 !important;
  /* border-color: #1ab394; */
  border: none;
}
.cancel_btn {
  border-radius: 4px;
}
.tabactive {
  background-color: #80ced7;
}
.forsecondtab {
  margin-left: auto;
}
.modalcontents {
  overflow-x:auto;
  overflow-y:auto;
  padding:10px;
  max-height:calc(100vh - 120px)
}
.rangeclass {
  width: 100%;
}
.cursor-pointer {
  cursor: pointer;
}

.position-relative {
  position: relative;
}

.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 0;
  top: -35px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.position-relative:hover .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.box {
  min-width: 100%;
  height: 43px;
  line-height: 100px;
  margin-top: 10px;
  opacity: 1;
  /* transition: opacity 0.5s; */
  border: solid;
  border-width: 1px;
  border-color: #c7c7c8;
  display: flex;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
img {
  max-width: 100%;
}

.navpadding {
  padding-bottom: 15px;
}

.elementsmenu {
  margin-left: 5px;
  width: 100px;
}

.elements_container {
  height: 460px;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.elements_container {
  overflow-y: scroll; /* add a vertical scroll bar */
  scrollbar-width: thin; /* set the width of the scrollbar */
  scrollbar-color: #333 #fff; /* set the color of the scrollbar */
}

/* Customize the appearance of the scrollbar */
.rowcolmn {
  margin-top: 0px;
  display: flex;
  gap: 5px;
  margin: 10px;
}
.elements_container::-webkit-scrollbar {
  width: 8px;
}

.elements_container::-webkit-scrollbar-thumb {
  background-color: #85a0d1;
  border-radius: 8px;
}
.dummydataenter {
  background-color: #c5c5e2;
}
.hiddenfile {
  display: none;
}
/* .twoitemflex{
  display:flex;
} */
.elements_container::-webkit-scrollbar-track {
  background-color: #fff;
  border-radius: 8px;
}
@media (max-width: 768px) {
  .md-block > * {
    display: block;
    margin: auto;
  }

  .elements-margins {
    margin-top: 3px;
    margin-bottom: 3px;
  }

  .elements-margins-large {
    margin: 0px !important;
    padding: 0px 5px 0px 8px !important;
  }
  .addcontainer {
    width: 79%;
  }
  .totaldiv {
    min-height: 300px;
  }
  .navbar.navbar-static-top {
    padding: 0 1rem !important;
  }
  iframe {
    position: absolute;
    float: left;
    clear: both;
    width: 100%;
    height: 350px;
    z-index: 0;
    left: no-repeat;
  }
  .navbar-header {
    align-self: center;
  }
  .flex-item {
    background-color: #f0f0ff !important;
  }
  .minimalize-styl-2 {
    margin: 0 !important;
  }

  .nav > li > a {
    font-size: 1.2em;
    padding: 1rem;
  }

  .nav > li > a i {
    font-size: 1em;
  }

  #wrapper {
    position: relative !important;
  }

  .pace-done #page-wrapper,
  .body.mini-navbar #page-wrapper {
    width: 100% !important;
  }

  .mini-navbar #mobilemenu > div {
    width: 0px;
    transition: width ease-in-out 400ms !important;
  }
}
.tab-pane {
  padding: 10px;
  background-color: #c4cfff;
}
.radiohorizondalclass {
  display: flex;
  gap: 2;
  flex-wrap: wrap;
}
.maxheight {
  height: 86%;
}
.maxheightdesigncomplete {
  height: 270px;
}
.option-error-block {
  color: hsl(0, 100%, 50%);
}
.font-15{
  font-size:15px;
}
.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 999; /* Make sure overlay is above the iframe */
}
.repeatContainer{
  border:2px dashed #676a6c;
}
.showbtms {
  position: relative; /* Ensures the icon can be absolutely positioned within this div */
}

.delete-icon {
  position: absolute;
  top: 0px;
  right: 5px;
  cursor: pointer;
  display: none; /* Hide the icon initially */
  font-size: 16px;
}

.showbtms:hover .delete-icon {
  display: block; /* Show the icon on hover */
}
.margintop {
    margin-top: -17px;
}
.loading-btn-img {
  display:block;
  mix-blend-mode: lighten;
}
.disabled-btn{
  opacity: 0.7
}
.scroll_horizontal{
  height: 550px;
  overflow: auto;
}
.fill-form-select{
    display: block;
    padding: 0.2rem 0.75rem;
    -moz-padding-start: calc(0.75rem - 3px);
    font-size: .8rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
    border-radius: 3px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.dependency .tool-tip {
  visibility: hidden;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    background-color: #616161;
    color: #fff;
    text-align: center;
    border-radius: 0.3em;
    padding: 0.2rem 0.7rem;
    right: 5px;
    top: -3px;
    font-size: 0.7rem;
    position: absolute;
    z-index: 1;
    transition: visibility 75ms ease-in;
}
.dependency :hover .tool-tip,
.dependency :focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
</style>
